import {
  Companion_getInstance3a5neho85mvmw as Companion_getInstance,
  Companion_getInstance1z0h5xsn2wljo as Companion_getInstance_0,
} from './subsidyRates.mjs';
import {
  get_serializableProperties1162nosnaangd as get_serializableProperties,
  SerializableProperty3cbm268cpjr8q as SerializableProperty,
} from '../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializableProperty.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Companion_getInstance1mublje3xr06o as Companion_getInstance_1,
  Companion_getInstance3jy8p8cx6vq5r as Companion_getInstance_2,
  Companion_getInstance2w6kuu6hdtz7s as Companion_getInstance_3,
} from './excelInputs.mjs';
import {
  Companion_getInstance1ymz2mf6vmsl4 as Companion_getInstance_4,
  Companion_instance1ucbvdkx25cw as Companion_instance,
  Companion_instance33tvqjkvwv8e1 as Companion_instance_0,
} from './employerAggregations.mjs';
import { Companion_instance9ofeumbwb97p as Companion_instance_1 } from './notifications.mjs';
import {
  Companion_instanceka5seqar5yvk as Companion_instance_2,
  Companion_instancelmyt635fcx9j as Companion_instance_3,
  Companion_instance3cnh73pq3p9e as Companion_instance_4,
  Companion_instance1d8b451omsiul as Companion_instance_5,
  Companion_instance3rsay32qgy1xl as Companion_instance_6,
  Companion_getInstance1ytzay7iyj05v as Companion_getInstance_5,
  Companion_getInstance2ufvbwwa42es2 as Companion_getInstance_6,
  Companion_instance1rfwfy6nwd43q as Companion_instance_7,
  Companion_instance1zp2bd525ftuh as Companion_instance_8,
} from './money.mjs';
import { Companion_instance1tjb9nvha71oi as Companion_instance_9 } from './dynamicSettings.mjs';
import {
  Companion_getInstance1ljiqntaxe0m9 as Companion_getInstance_7,
  Companion_getInstance2r6pafkc2qafn as Companion_getInstance_8,
  Companion_instancen4rpxo41w4o4 as Companion_instance_10,
} from './models.mjs';
import {
  Companion_instance1a4q68acbdhgb as Companion_instance_11,
  Companion_instance1eu9vz7wcioa as Companion_instance_12,
  Companion_getInstance2n667ht97uzau as Companion_getInstance_9,
  Companion_instanceqxewwv101ea8 as Companion_instance_13,
  Companion_instancen1zs0vnqjbin as Companion_instance_14,
} from './types.mjs';
import {
  Companion_getInstance2jaanzr07h9qp as Companion_getInstance_10,
  Companion_instanceh1a9dxwm5f9z as Companion_instance_15,
  Companion_getInstance2jmr19i6t9ie as Companion_getInstance_11,
  Companion_instance1ujmr6an7etn7 as Companion_instance_16,
  Companion_getInstance8cw09c4jvk3w as Companion_getInstance_12,
  Companion_getInstance3n8qsn7k1orly as Companion_getInstance_13,
  Companion_instance12ap9399n2dhe as Companion_instance_17,
  Companion_instance3qb7v2pipun4h as Companion_instance_18,
  Companion_instance3147idamxrkdi as Companion_instance_19,
  Companion_getInstance29yv2m82qhueb as Companion_getInstance_14,
  Companion_instance3i4ej7wheox62 as Companion_instance_20,
  Companion_getInstance3624xnlg0493t as Companion_getInstance_15,
  Companion_getInstance5c3fz7snx10k as Companion_getInstance_16,
  Companion_instance31zndpf9pf1oi as Companion_instance_21,
  Companion_instance2mni8afnohjti as Companion_instance_22,
  Companion_instanceu8ez89pi8m0d as Companion_instance_23,
} from './domain.mjs';
import {
  Companion_getInstancevgnjncsigc6q as Companion_getInstance_17,
  Companion_getInstanceuh3bufkg8gwa as Companion_getInstance_18,
  Companion_instance320a6ll7l9qyv as Companion_instance_24,
  Companion_getInstance2yczpxlc95n6h as Companion_getInstance_19,
  Companion_instance2qg1ehow26tib as Companion_instance_25,
  Companion_instanceebautjfvyshn as Companion_instance_26,
} from './applications.mjs';
import {
  Companion_getInstance3rx4dbijulyuv as Companion_getInstance_20,
  Companion_instancesqd80ja9ulcs as Companion_instance_27,
  Companion_getInstanceyrbofvk90ue2 as Companion_getInstance_21,
  Companion_instance2km53rz6tjv2o as Companion_instance_28,
} from './careRates.mjs';
import {
  Companion_getInstance67t3dbcjzlfh as Companion_getInstance_22,
  Companion_getInstancek2mwqkcqpws as Companion_getInstance_23,
  Companion_getInstance305gia6954odo as Companion_getInstance_24,
  Companion_getInstance29sht6afyr9n6 as Companion_getInstance_25,
  Companion_getInstance1tychjrdxpayy as Companion_getInstance_26,
  Companion_getInstancecv02zznkeg7m as Companion_getInstance_27,
} from './survey.mjs';
import {
  Companion_getInstance2chr590t9enwa as Companion_getInstance_28,
  Companion_getInstancen8xc5ca99en9 as Companion_getInstance_29,
  Companion_getInstance28su32ptmydjz as Companion_getInstance_30,
} from './esignature.mjs';
import {
  Companion_getInstance3lyiwdpjexugx as Companion_getInstance_31,
  Companion_getInstance1ts49hpe5lvz6 as Companion_getInstance_32,
  Companion_getInstance27kcs909wdme9 as Companion_getInstance_33,
} from './attendance.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_EmployerRate__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return EmployerRate__properties;
}
var EmployerRate__properties;
var EmployerRate__id;
function get_EmployerRate_employer() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return EmployerRate_employer;
}
var EmployerRate_employer;
function get_EmployerRate_activeRange() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return EmployerRate_activeRange;
}
var EmployerRate_activeRange;
function get_EmployerRate_administration() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return EmployerRate_administration;
}
var EmployerRate_administration;
function get_EmployerRate_careProvider() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return EmployerRate_careProvider;
}
var EmployerRate_careProvider;
function get_GrantRate__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return GrantRate__properties;
}
var GrantRate__properties;
var GrantRate__id;
function get_GrantRate_grant() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return GrantRate_grant;
}
var GrantRate_grant;
function get_GrantRate_activeRange() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return GrantRate_activeRange;
}
var GrantRate_activeRange;
function get_GrantRate_administration() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return GrantRate_administration;
}
var GrantRate_administration;
function get_GrantRate_careProvider() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return GrantRate_careProvider;
}
var GrantRate_careProvider;
var GrantRate_eligibility;
function get_CareDayInfo__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareDayInfo__properties;
}
var CareDayInfo__properties;
var CareDayInfo_owed;
var CareDayInfo_time;
var CareDayInfo_ageMonths;
var CareDayInfo_transport;
function get_CareDayInfoWithEmployerSubsidy__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareDayInfoWithEmployerSubsidy__properties;
}
var CareDayInfoWithEmployerSubsidy__properties;
var CareDayInfoWithEmployerSubsidy_owed;
var CareDayInfoWithEmployerSubsidy_time;
var CareDayInfoWithEmployerSubsidy_ageMonths;
var CareDayInfoWithEmployerSubsidy_transport;
var CareDayInfoWithEmployerSubsidy_paidByEmployer;
function get_CareDayInfoWithSubsidies__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareDayInfoWithSubsidies__properties;
}
var CareDayInfoWithSubsidies__properties;
var CareDayInfoWithSubsidies_owed;
var CareDayInfoWithSubsidies_time;
var CareDayInfoWithSubsidies_ageMonths;
var CareDayInfoWithSubsidies_transport;
var CareDayInfoWithSubsidies_paidByEmployer;
var CareDayInfoWithSubsidies_paidByGrant;
function get_EmployerMonthAggregates__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return EmployerMonthAggregates__properties;
}
var EmployerMonthAggregates__properties;
var EmployerMonthAggregates__id;
function get_EmployerMonthAggregates_employer() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return EmployerMonthAggregates_employer;
}
var EmployerMonthAggregates_employer;
function get_EmployerMonthAggregates_month() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return EmployerMonthAggregates_month;
}
var EmployerMonthAggregates_month;
function get_EmployerMonthAggregates_breakdown() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return EmployerMonthAggregates_breakdown;
}
var EmployerMonthAggregates_breakdown;
var EmployerMonthAggregates_total;
var EmployerMonthAggregates_byAgeGroup;
var EmployerMonthAggregates_byProviderType;
function get_EmployerMonthAggregates_Stats__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return EmployerMonthAggregates_Stats__properties;
}
var EmployerMonthAggregates_Stats__properties;
var EmployerMonthAggregates_Stats_childPlacements;
var EmployerMonthAggregates_Stats_children;
var EmployerMonthAggregates_Stats_families;
function get_EmployerMonthAggregates_MoneyBreakdown__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return EmployerMonthAggregates_MoneyBreakdown__properties;
}
var EmployerMonthAggregates_MoneyBreakdown__properties;
var EmployerMonthAggregates_MoneyBreakdown_totalCostOfCare;
var EmployerMonthAggregates_MoneyBreakdown_employerShare;
var EmployerMonthAggregates_MoneyBreakdown_employerAdministrationFee;
var EmployerMonthAggregates_MoneyBreakdown_grantMatch;
function get_TCGNotification__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return TCGNotification__properties;
}
var TCGNotification__properties;
var TCGNotification_subject;
var TCGNotification_body;
var TCGNotification_url;
function get_AccountingSyncInfo__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return AccountingSyncInfo__properties;
}
var AccountingSyncInfo__properties;
var AccountingSyncInfo_lastSync;
var AccountingSyncInfo_documentNumber;
var AccountingSyncInfo_foreignId;
var AccountingSyncInfo_reversedBy;
function get_AccountingSyncInfo_LastSync__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return AccountingSyncInfo_LastSync__properties;
}
var AccountingSyncInfo_LastSync__properties;
var AccountingSyncInfo_LastSync_at;
var AccountingSyncInfo_LastSync_issue;
var AccountingSyncInfo_LastSync_shouldContinueSyncing;
function get_AccountState__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return AccountState__properties;
}
var AccountState__properties;
var AccountState_at;
var AccountState_balance;
function get_GrantAccountTransaction__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return GrantAccountTransaction__properties;
}
var GrantAccountTransaction__properties;
var GrantAccountTransaction__id;
function get_GrantAccountTransaction_grant() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return GrantAccountTransaction_grant;
}
var GrantAccountTransaction_grant;
var GrantAccountTransaction_amount;
function get_GrantAccountTransaction_at() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return GrantAccountTransaction_at;
}
var GrantAccountTransaction_at;
function get_GrantAccountTransaction_reason() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return GrantAccountTransaction_reason;
}
var GrantAccountTransaction_reason;
var GrantAccountTransaction_pulledFrom;
function get_GrantAccountTransaction_voided() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return GrantAccountTransaction_voided;
}
var GrantAccountTransaction_voided;
function get_EmployerAccountTransaction__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return EmployerAccountTransaction__properties;
}
var EmployerAccountTransaction__properties;
var EmployerAccountTransaction__id;
function get_EmployerAccountTransaction_employer() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return EmployerAccountTransaction_employer;
}
var EmployerAccountTransaction_employer;
var EmployerAccountTransaction_amount;
function get_EmployerAccountTransaction_at() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return EmployerAccountTransaction_at;
}
var EmployerAccountTransaction_at;
function get_EmployerAccountTransaction_reason() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return EmployerAccountTransaction_reason;
}
var EmployerAccountTransaction_reason;
var EmployerAccountTransaction_pulledFrom;
function get_EmployerAccountTransaction_voided() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return EmployerAccountTransaction_voided;
}
var EmployerAccountTransaction_voided;
function get_CareProviderRemittance__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProviderRemittance__properties;
}
var CareProviderRemittance__properties;
var CareProviderRemittance__id;
function get_CareProviderRemittance_provider() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProviderRemittance_provider;
}
var CareProviderRemittance_provider;
function get_CareProviderRemittance_forDates() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProviderRemittance_forDates;
}
var CareProviderRemittance_forDates;
var CareProviderRemittance_at;
function get_CareProviderRemittance_amount() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProviderRemittance_amount;
}
var CareProviderRemittance_amount;
function get_CareProviderRemittance_status() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProviderRemittance_status;
}
var CareProviderRemittance_status;
function get_CareProviderRemittance_voided() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProviderRemittance_voided;
}
var CareProviderRemittance_voided;
var CareProviderRemittance_sync;
function get_CareProviderRemittance_SingleChildDay__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProviderRemittance_SingleChildDay__properties;
}
var CareProviderRemittance_SingleChildDay__properties;
var CareProviderRemittance_SingleChildDay__id;
function get_CareProviderRemittance_SingleChildDay_remittance() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProviderRemittance_SingleChildDay_remittance;
}
var CareProviderRemittance_SingleChildDay_remittance;
var CareProviderRemittance_SingleChildDay_placement;
function get_CareProviderRemittance_SingleChildDay_family() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProviderRemittance_SingleChildDay_family;
}
var CareProviderRemittance_SingleChildDay_family;
function get_CareProviderRemittance_SingleChildDay_location() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProviderRemittance_SingleChildDay_location;
}
var CareProviderRemittance_SingleChildDay_location;
function get_CareProviderRemittance_SingleChildDay_provider() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProviderRemittance_SingleChildDay_provider;
}
var CareProviderRemittance_SingleChildDay_provider;
var CareProviderRemittance_SingleChildDay_program;
function get_CareProviderRemittance_SingleChildDay_forDate() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProviderRemittance_SingleChildDay_forDate;
}
var CareProviderRemittance_SingleChildDay_forDate;
var CareProviderRemittance_SingleChildDay_price;
function get_CareProviderRemittance_SingleChildDay_grantContributions() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProviderRemittance_SingleChildDay_grantContributions;
}
var CareProviderRemittance_SingleChildDay_grantContributions;
function get_CareProviderRemittance_SingleChildDay_employerContributions() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProviderRemittance_SingleChildDay_employerContributions;
}
var CareProviderRemittance_SingleChildDay_employerContributions;
var CareProviderRemittance_SingleChildDay_totalContributions;
var CareProviderRemittance_SingleChildDay_paidByFamily;
var CareProviderRemittance_SingleChildDay_attendance;
function get_CareProviderRemittance_SingleChildDay_voided() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProviderRemittance_SingleChildDay_voided;
}
var CareProviderRemittance_SingleChildDay_voided;
function get_CareProviderRemittance_SingleChildDay_GrantContribution__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProviderRemittance_SingleChildDay_GrantContribution__properties;
}
var CareProviderRemittance_SingleChildDay_GrantContribution__properties;
function get_CareProviderRemittance_SingleChildDay_GrantContribution_grant() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProviderRemittance_SingleChildDay_GrantContribution_grant;
}
var CareProviderRemittance_SingleChildDay_GrantContribution_grant;
var CareProviderRemittance_SingleChildDay_GrantContribution_amount;
var CareProviderRemittance_SingleChildDay_GrantContribution_administrativeCharge;
function get_CareProviderRemittance_SingleChildDay_EmployerContribution__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProviderRemittance_SingleChildDay_EmployerContribution__properties;
}
var CareProviderRemittance_SingleChildDay_EmployerContribution__properties;
function get_CareProviderRemittance_SingleChildDay_EmployerContribution_employer() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProviderRemittance_SingleChildDay_EmployerContribution_employer;
}
var CareProviderRemittance_SingleChildDay_EmployerContribution_employer;
var CareProviderRemittance_SingleChildDay_EmployerContribution_amount;
var CareProviderRemittance_SingleChildDay_EmployerContribution_administrativeCharge;
function get_DynamicSettings__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return DynamicSettings__properties;
}
var DynamicSettings__properties;
var DynamicSettings__id;
var DynamicSettings_placementAgreementTemplate;
var DynamicSettings_placementAgreementSubject;
var DynamicSettings_placementAgreementMessage;
var DynamicSettings_employerAgreementTemplate;
var DynamicSettings_employerAgreementSubject;
var DynamicSettings_employerAgreementMessage;
var DynamicSettings_tcgSigner;
function get_AppRelease__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return AppRelease__properties;
}
var AppRelease__properties;
var AppRelease__id;
var AppRelease_version;
function get_AppRelease_platform() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return AppRelease_platform;
}
var AppRelease_platform;
var AppRelease_releaseDate;
var AppRelease_requiredUpdate;
function get_User__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return User__properties;
}
var User__properties;
function get_User__id() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return User__id;
}
var User__id;
function get_User_email() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return User_email;
}
var User_email;
function get_User_name() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return User_name;
}
var User_name;
function get_User_phone() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return User_phone;
}
var User_phone;
function get_User_preferredLanguage() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return User_preferredLanguage;
}
var User_preferredLanguage;
function get_User_role() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return User_role;
}
var User_role;
function get_User_managesEmployers() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return User_managesEmployers;
}
var User_managesEmployers;
function get_User_managesProviders() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return User_managesProviders;
}
var User_managesProviders;
function get_User_managesLocations() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return User_managesLocations;
}
var User_managesLocations;
function get_User_managesFamilies() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return User_managesFamilies;
}
var User_managesFamilies;
function get_User_createdAt() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return User_createdAt;
}
var User_createdAt;
var User_updatedAt;
function get_User_active() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return User_active;
}
var User_active;
function get_FcmToken__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return FcmToken__properties;
}
var FcmToken__properties;
var FcmToken__id;
var FcmToken_user;
var FcmToken_active;
var FcmToken_created;
var FcmToken_lastRegisteredAt;
var FcmToken_userAgent;
function get_ClosedLocalDateRange__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ClosedLocalDateRange__properties;
}
var ClosedLocalDateRange__properties;
function get_ClosedLocalDateRange_start() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ClosedLocalDateRange_start;
}
var ClosedLocalDateRange_start;
function get_ClosedLocalDateRange_endInclusive() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ClosedLocalDateRange_endInclusive;
}
var ClosedLocalDateRange_endInclusive;
function get_LocalDateRange__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return LocalDateRange__properties;
}
var LocalDateRange__properties;
function get_LocalDateRange_start() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return LocalDateRange_start;
}
var LocalDateRange_start;
function get_LocalDateRange_endInclusive() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return LocalDateRange_endInclusive;
}
var LocalDateRange_endInclusive;
function get_RecordedAction__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return RecordedAction__properties;
}
var RecordedAction__properties;
var RecordedAction_by;
var RecordedAction_at;
var RecordedAction_reason;
function get_ContactInfo__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ContactInfo__properties;
}
var ContactInfo__properties;
function get_ContactInfo_name() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ContactInfo_name;
}
var ContactInfo_name;
function get_ContactInfo_email() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ContactInfo_email;
}
var ContactInfo_email;
function get_ContactInfo_phone() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ContactInfo_phone;
}
var ContactInfo_phone;
function get_Address__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Address__properties;
}
var Address__properties;
function get_Address_line1() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Address_line1;
}
var Address_line1;
function get_Address_line2() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Address_line2;
}
var Address_line2;
function get_Address_city() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Address_city;
}
var Address_city;
function get_Address_state() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Address_state;
}
var Address_state;
function get_Address_postalCode() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Address_postalCode;
}
var Address_postalCode;
var Address_geo;
function get_Family__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Family__properties;
}
var Family__properties;
function get_Family__id() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Family__id;
}
var Family__id;
function get_Family_shortId() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Family_shortId;
}
var Family_shortId;
function get_Family_primaryParent() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Family_primaryParent;
}
var Family_primaryParent;
function get_Family_secondaryParent() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Family_secondaryParent;
}
var Family_secondaryParent;
var Family_childNames;
var Family_income;
function get_Family_familySize() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Family_familySize;
}
var Family_familySize;
function get_Family_address() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Family_address;
}
var Family_address;
var Family_mailingAddress;
function get_Family_informationVerifiedAt() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Family_informationVerifiedAt;
}
var Family_informationVerifiedAt;
function get_Family_active() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Family_active;
}
var Family_active;
function get_FamilyEmployerAuthorization__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return FamilyEmployerAuthorization__properties;
}
var FamilyEmployerAuthorization__properties;
function get_FamilyEmployerAuthorization__id() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return FamilyEmployerAuthorization__id;
}
var FamilyEmployerAuthorization__id;
function get_FamilyEmployerAuthorization_family() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return FamilyEmployerAuthorization_family;
}
var FamilyEmployerAuthorization_family;
var FamilyEmployerAuthorization_employer;
function get_FamilyEmployerAuthorization_activeRange() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return FamilyEmployerAuthorization_activeRange;
}
var FamilyEmployerAuthorization_activeRange;
function get_Parent__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Parent__properties;
}
var Parent__properties;
function get_Parent_firstName() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Parent_firstName;
}
var Parent_firstName;
function get_Parent_lastName() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Parent_lastName;
}
var Parent_lastName;
function get_Parent_email() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Parent_email;
}
var Parent_email;
function get_Parent_phone() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Parent_phone;
}
var Parent_phone;
function get_Parent_alternatePhone() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Parent_alternatePhone;
}
var Parent_alternatePhone;
function get_Parent_preferredLanguage() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Parent_preferredLanguage;
}
var Parent_preferredLanguage;
function get_Parent_race() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Parent_race;
}
var Parent_race;
function get_Parent_gender() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Parent_gender;
}
var Parent_gender;
function get_Parent_birthDate() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Parent_birthDate;
}
var Parent_birthDate;
function get_IncomeRange__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return IncomeRange__properties;
}
var IncomeRange__properties;
var IncomeRange_min;
var IncomeRange_max;
function get_Child__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Child__properties;
}
var Child__properties;
var Child__id;
function get_Child_family() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Child_family;
}
var Child_family;
function get_Child_firstName() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Child_firstName;
}
var Child_firstName;
function get_Child_lastName() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Child_lastName;
}
var Child_lastName;
function get_Child_birthDate() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Child_birthDate;
}
var Child_birthDate;
function get_Child_notes() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Child_notes;
}
var Child_notes;
function get_Child_race() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Child_race;
}
var Child_race;
function get_Child_gender() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Child_gender;
}
var Child_gender;
function get_Child_active() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Child_active;
}
var Child_active;
function get_ChildPlacement__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ChildPlacement__properties;
}
var ChildPlacement__properties;
function get_ChildPlacement__id() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ChildPlacement__id;
}
var ChildPlacement__id;
function get_ChildPlacement_child() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ChildPlacement_child;
}
var ChildPlacement_child;
function get_ChildPlacement_childName() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ChildPlacement_childName;
}
var ChildPlacement_childName;
var ChildPlacement_childBirthDate;
function get_ChildPlacement_family() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ChildPlacement_family;
}
var ChildPlacement_family;
function get_ChildPlacement_location() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ChildPlacement_location;
}
var ChildPlacement_location;
function get_ChildPlacement_provider() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ChildPlacement_provider;
}
var ChildPlacement_provider;
var ChildPlacement_authorizations;
function get_ChildPlacement_employers() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ChildPlacement_employers;
}
var ChildPlacement_employers;
function get_ChildPlacement_grants() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ChildPlacement_grants;
}
var ChildPlacement_grants;
var ChildPlacement_schedule;
function get_ChildPlacement_activeRange() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ChildPlacement_activeRange;
}
var ChildPlacement_activeRange;
function get_ChildPlacement_endReason() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ChildPlacement_endReason;
}
var ChildPlacement_endReason;
function get_ChildPlacement_endReasonNotes() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ChildPlacement_endReasonNotes;
}
var ChildPlacement_endReasonNotes;
var ChildPlacement_signingInfo;
function get_ChildPlacement_signedDocument() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ChildPlacement_signedDocument;
}
var ChildPlacement_signedDocument;
function get_ChildPlacement_active() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ChildPlacement_active;
}
var ChildPlacement_active;
function get_ChildPlacement_SignedDocument__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ChildPlacement_SignedDocument__properties;
}
var ChildPlacement_SignedDocument__properties;
var ChildPlacement_SignedDocument_file;
var ChildPlacement_SignedDocument_at;
function get_ChildPlacement_Schedule__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ChildPlacement_Schedule__properties;
}
var ChildPlacement_Schedule__properties;
var ChildPlacement_Schedule_monday;
var ChildPlacement_Schedule_tuesday;
var ChildPlacement_Schedule_wednesday;
var ChildPlacement_Schedule_thursday;
var ChildPlacement_Schedule_friday;
var ChildPlacement_Schedule_saturday;
var ChildPlacement_Schedule_sunday;
function get_ChildPlacement_Schedule_Day__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ChildPlacement_Schedule_Day__properties;
}
var ChildPlacement_Schedule_Day__properties;
var ChildPlacement_Schedule_Day_program;
var ChildPlacement_Schedule_Day_transportFrom;
var ChildPlacement_Schedule_Day_transportTo;
var ChildPlacement_Schedule_Day_programWhenIntermittent;
function get_ChildAttendance__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ChildAttendance__properties;
}
var ChildAttendance__properties;
var ChildAttendance__id;
var ChildAttendance_placement;
var ChildAttendance_child;
var ChildAttendance_family;
var ChildAttendance_employers;
var ChildAttendance_grants;
function get_ChildAttendance_location() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ChildAttendance_location;
}
var ChildAttendance_location;
var ChildAttendance_provider;
function get_ChildAttendance_date() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ChildAttendance_date;
}
var ChildAttendance_date;
function get_ChildAttendance_attendance() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ChildAttendance_attendance;
}
var ChildAttendance_attendance;
function get_CareProvider__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProvider__properties;
}
var CareProvider__properties;
function get_CareProvider__id() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProvider__id;
}
var CareProvider__id;
function get_CareProvider_name() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProvider_name;
}
var CareProvider_name;
function get_CareProvider_contact() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProvider_contact;
}
var CareProvider_contact;
function get_CareProvider_vendorNumber() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProvider_vendorNumber;
}
var CareProvider_vendorNumber;
var CareProvider_sync;
function get_CareProvider_offersTransportation() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProvider_offersTransportation;
}
var CareProvider_offersTransportation;
function get_CareProvider_active() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProvider_active;
}
var CareProvider_active;
function get_CareLocation__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareLocation__properties;
}
var CareLocation__properties;
function get_CareLocation__id() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareLocation__id;
}
var CareLocation__id;
function get_CareLocation_provider() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareLocation_provider;
}
var CareLocation_provider;
function get_CareLocation_providerName() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareLocation_providerName;
}
var CareLocation_providerName;
function get_CareLocation_type() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareLocation_type;
}
var CareLocation_type;
function get_CareLocation_name() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareLocation_name;
}
var CareLocation_name;
function get_CareLocation_address() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareLocation_address;
}
var CareLocation_address;
function get_CareLocation_contact() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareLocation_contact;
}
var CareLocation_contact;
function get_CareLocation_active() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareLocation_active;
}
var CareLocation_active;
function get_CareLocationClosure__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareLocationClosure__properties;
}
var CareLocationClosure__properties;
var CareLocationClosure__id;
var CareLocationClosure_provider;
function get_CareLocationClosure_location() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareLocationClosure_location;
}
var CareLocationClosure_location;
function get_CareLocationClosure_date() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareLocationClosure_date;
}
var CareLocationClosure_date;
function get_CareLocationClosure_reason() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareLocationClosure_reason;
}
var CareLocationClosure_reason;
var CareLocationClosure_submitted;
function get_LocationAttendancePeriod__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return LocationAttendancePeriod__properties;
}
var LocationAttendancePeriod__properties;
var LocationAttendancePeriod__id;
function get_LocationAttendancePeriod_location() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return LocationAttendancePeriod_location;
}
var LocationAttendancePeriod_location;
function get_LocationAttendancePeriod_provider() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return LocationAttendancePeriod_provider;
}
var LocationAttendancePeriod_provider;
function get_LocationAttendancePeriod_period() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return LocationAttendancePeriod_period;
}
var LocationAttendancePeriod_period;
function get_LocationAttendancePeriod_submitted() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return LocationAttendancePeriod_submitted;
}
var LocationAttendancePeriod_submitted;
function get_LocationAttendancePeriod_approved() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return LocationAttendancePeriod_approved;
}
var LocationAttendancePeriod_approved;
function get_Employer__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Employer__properties;
}
var Employer__properties;
function get_Employer__id() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Employer__id;
}
var Employer__id;
function get_Employer_name() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Employer_name;
}
var Employer_name;
function get_Employer_contact() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Employer_contact;
}
var Employer_contact;
function get_Employer_billingAddress() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Employer_billingAddress;
}
var Employer_billingAddress;
function get_Employer_billingContactName() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Employer_billingContactName;
}
var Employer_billingContactName;
var Employer_sync;
var Employer_balance;
var Employer_signingInfo;
var Employer_signedDocument;
function get_Employer_active() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Employer_active;
}
var Employer_active;
function get_Grant__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Grant__properties;
}
var Grant__properties;
function get_Grant__id() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Grant__id;
}
var Grant__id;
function get_Grant_name() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Grant_name;
}
var Grant_name;
function get_Grant_funder() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Grant_funder;
}
var Grant_funder;
function get_Grant_activeRange() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Grant_activeRange;
}
var Grant_activeRange;
var Grant_sync;
var Grant_balance;
function get_FamilyApplication__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return FamilyApplication__properties;
}
var FamilyApplication__properties;
var FamilyApplication__id;
function get_FamilyApplication_employer() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return FamilyApplication_employer;
}
var FamilyApplication_employer;
function get_FamilyApplication_sentTo() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return FamilyApplication_sentTo;
}
var FamilyApplication_sentTo;
function get_FamilyApplication_createdAt() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return FamilyApplication_createdAt;
}
var FamilyApplication_createdAt;
function get_FamilyApplication_invitedUsers() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return FamilyApplication_invitedUsers;
}
var FamilyApplication_invitedUsers;
function get_FamilyApplication_submission() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return FamilyApplication_submission;
}
var FamilyApplication_submission;
function get_FamilyApplication_review() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return FamilyApplication_review;
}
var FamilyApplication_review;
function get_FamilyApplication_Submission__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return FamilyApplication_Submission__properties;
}
var FamilyApplication_Submission__properties;
var FamilyApplication_Submission_submittedAt;
function get_FamilyApplication_Submission_family() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return FamilyApplication_Submission_family;
}
var FamilyApplication_Submission_family;
function get_FamilyApplication_Submission_children() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return FamilyApplication_Submission_children;
}
var FamilyApplication_Submission_children;
function get_FamilyApplication_Review__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return FamilyApplication_Review__properties;
}
var FamilyApplication_Review__properties;
var FamilyApplication_Review_reviewedAt;
function get_FamilyApplication_Review_approved() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return FamilyApplication_Review_approved;
}
var FamilyApplication_Review_approved;
var FamilyApplication_Review_resultingFamily;
function get_ProviderApplication__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ProviderApplication__properties;
}
var ProviderApplication__properties;
var ProviderApplication__id;
function get_ProviderApplication_sentTo() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ProviderApplication_sentTo;
}
var ProviderApplication_sentTo;
function get_ProviderApplication_createdAt() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ProviderApplication_createdAt;
}
var ProviderApplication_createdAt;
function get_ProviderApplication_invitedUsers() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ProviderApplication_invitedUsers;
}
var ProviderApplication_invitedUsers;
function get_ProviderApplication_submission() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ProviderApplication_submission;
}
var ProviderApplication_submission;
function get_ProviderApplication_review() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ProviderApplication_review;
}
var ProviderApplication_review;
function get_ProviderApplication_Submission__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ProviderApplication_Submission__properties;
}
var ProviderApplication_Submission__properties;
var ProviderApplication_Submission_submittedAt;
function get_ProviderApplication_Submission_provider() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ProviderApplication_Submission_provider;
}
var ProviderApplication_Submission_provider;
function get_ProviderApplication_Review__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ProviderApplication_Review__properties;
}
var ProviderApplication_Review__properties;
var ProviderApplication_Review_reviewedAt;
function get_ProviderApplication_Review_approved() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ProviderApplication_Review_approved;
}
var ProviderApplication_Review_approved;
var ProviderApplication_Review_resultingProvider;
function get_CareLocationProgram__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareLocationProgram__properties;
}
var CareLocationProgram__properties;
function get_CareLocationProgram__id() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareLocationProgram__id;
}
var CareLocationProgram__id;
function get_CareLocationProgram_location() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareLocationProgram_location;
}
var CareLocationProgram_location;
var CareLocationProgram_provider;
var CareLocationProgram_name;
function get_CareLocationProgram_template() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareLocationProgram_template;
}
var CareLocationProgram_template;
function get_CareLocationProgram_templateSince() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareLocationProgram_templateSince;
}
var CareLocationProgram_templateSince;
var CareLocationProgram_active;
var CareLocationProgram_careTime;
var CareLocationProgram_ageStart;
var CareLocationProgram_ageEndInclusive;
var CareLocationProgram_availableAsIntermittent;
function get_CareLocationProgramDated__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareLocationProgramDated__properties;
}
var CareLocationProgramDated__properties;
var CareLocationProgramDated__id;
function get_CareLocationProgramDated_program() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareLocationProgramDated_program;
}
var CareLocationProgramDated_program;
var CareLocationProgramDated_location;
var CareLocationProgramDated_provider;
var CareLocationProgramDated_template;
var CareLocationProgramDated_name;
var CareLocationProgramDated_templateDated;
function get_CareLocationProgramDated_activeRange() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareLocationProgramDated_activeRange;
}
var CareLocationProgramDated_activeRange;
var CareLocationProgramDated_price;
var CareLocationProgramDated_transportOneWay;
var CareLocationProgramDated_transportTwoWay;
function get_CareProgramTemplate__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProgramTemplate__properties;
}
var CareProgramTemplate__properties;
var CareProgramTemplate__id;
function get_CareProgramTemplate_name() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProgramTemplate_name;
}
var CareProgramTemplate_name;
function get_CareProgramTemplate_shortName() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProgramTemplate_shortName;
}
var CareProgramTemplate_shortName;
function get_CareProgramTemplate_careTime() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProgramTemplate_careTime;
}
var CareProgramTemplate_careTime;
function get_CareProgramTemplate_ageStart() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProgramTemplate_ageStart;
}
var CareProgramTemplate_ageStart;
function get_CareProgramTemplate_ageEndInclusive() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProgramTemplate_ageEndInclusive;
}
var CareProgramTemplate_ageEndInclusive;
function get_CareProgramTemplate_availableAsIntermittent() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProgramTemplate_availableAsIntermittent;
}
var CareProgramTemplate_availableAsIntermittent;
function get_CareProgramTemplateDated__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProgramTemplateDated__properties;
}
var CareProgramTemplateDated__properties;
var CareProgramTemplateDated__id;
function get_CareProgramTemplateDated_template() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProgramTemplateDated_template;
}
var CareProgramTemplateDated_template;
function get_CareProgramTemplateDated_activeRange() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProgramTemplateDated_activeRange;
}
var CareProgramTemplateDated_activeRange;
function get_CareProgramTemplateDated_price() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProgramTemplateDated_price;
}
var CareProgramTemplateDated_price;
function get_CareProgramTemplateDated_transportOneWay() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProgramTemplateDated_transportOneWay;
}
var CareProgramTemplateDated_transportOneWay;
function get_CareProgramTemplateDated_transportTwoWay() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return CareProgramTemplateDated_transportTwoWay;
}
var CareProgramTemplateDated_transportTwoWay;
function get_Survey__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Survey__properties;
}
var Survey__properties;
var Survey__id;
function get_Survey_name() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Survey_name;
}
var Survey_name;
function get_Survey_available() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Survey_available;
}
var Survey_available;
var Survey_maximumFrequency;
var Survey_questions;
var Survey_audience;
var Survey_translations;
function get_Question__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Question__properties;
}
var Question__properties;
var Question__id;
var Question_question;
var Question_item;
var Question_type;
var Question_optional;
var Question_employerMaySeeResponse;
var Question_showCondition;
function get_Question_ShowCondition__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return Question_ShowCondition__properties;
}
var Question_ShowCondition__properties;
var Question_ShowCondition_otherQuestion;
var Question_ShowCondition_answerIsOneOf;
function get_QuestionResponse__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return QuestionResponse__properties;
}
var QuestionResponse__properties;
var QuestionResponse__id;
function get_QuestionResponse_survey() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return QuestionResponse_survey;
}
var QuestionResponse_survey;
function get_QuestionResponse_question() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return QuestionResponse_question;
}
var QuestionResponse_question;
var QuestionResponse_takerType;
function get_QuestionResponse_takerId() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return QuestionResponse_takerId;
}
var QuestionResponse_takerId;
function get_QuestionResponse_takerIteration() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return QuestionResponse_takerIteration;
}
var QuestionResponse_takerIteration;
var QuestionResponse_employerMaySeeResponse;
function get_QuestionResponse_demographic() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return QuestionResponse_demographic;
}
var QuestionResponse_demographic;
function get_QuestionResponse_at() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return QuestionResponse_at;
}
var QuestionResponse_at;
var QuestionResponse_answerFreeText;
function get_QuestionResponse_answerSingleChoice() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return QuestionResponse_answerSingleChoice;
}
var QuestionResponse_answerSingleChoice;
function get_QuestionResponse_answerMultipleChoice() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return QuestionResponse_answerMultipleChoice;
}
var QuestionResponse_answerMultipleChoice;
function get_QuestionResponse_answerScale() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return QuestionResponse_answerScale;
}
var QuestionResponse_answerScale;
function get_QuestionResponse_answerFreeNumber() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return QuestionResponse_answerFreeNumber;
}
var QuestionResponse_answerFreeNumber;
function get_QuestionResponse_Demographic__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return QuestionResponse_Demographic__properties;
}
var QuestionResponse_Demographic__properties;
function get_QuestionResponse_Demographic_supportingEmployers() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return QuestionResponse_Demographic_supportingEmployers;
}
var QuestionResponse_Demographic_supportingEmployers;
function get_QuestionResponse_Demographic_supportingGrants() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return QuestionResponse_Demographic_supportingGrants;
}
var QuestionResponse_Demographic_supportingGrants;
function get_QuestionResponse_Demographic_takerEmployer() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return QuestionResponse_Demographic_takerEmployer;
}
var QuestionResponse_Demographic_takerEmployer;
function get_QuestionResponse_Demographic_income() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return QuestionResponse_Demographic_income;
}
var QuestionResponse_Demographic_income;
function get_QuestionResponse_Demographic_leadershipLevel() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return QuestionResponse_Demographic_leadershipLevel;
}
var QuestionResponse_Demographic_leadershipLevel;
function get_QuestionResponse_Demographic_familySize() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return QuestionResponse_Demographic_familySize;
}
var QuestionResponse_Demographic_familySize;
function get_QuestionResponse_Demographic_city() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return QuestionResponse_Demographic_city;
}
var QuestionResponse_Demographic_city;
function get_SurveyProgress__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return SurveyProgress__properties;
}
var SurveyProgress__properties;
var SurveyProgress__id;
function get_SurveyProgress_survey() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return SurveyProgress_survey;
}
var SurveyProgress_survey;
function get_SurveyProgress_takerType() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return SurveyProgress_takerType;
}
var SurveyProgress_takerType;
function get_SurveyProgress_takerId() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return SurveyProgress_takerId;
}
var SurveyProgress_takerId;
function get_SurveyProgress_takerIteration() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return SurveyProgress_takerIteration;
}
var SurveyProgress_takerIteration;
var SurveyProgress_demographic;
var SurveyProgress_startedAt;
function get_SurveyProgress_completedAt() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return SurveyProgress_completedAt;
}
var SurveyProgress_completedAt;
function get_SignatureSession__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return SignatureSession__properties;
}
var SignatureSession__properties;
var SignatureSession_envelopeId;
var SignatureSession_redirects;
var SignatureSession_expiresAt;
function get_SignerStatus__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return SignerStatus__properties;
}
var SignerStatus__properties;
var SignerStatus_email;
var SignerStatus_status;
function get_SignatureStatusDetails__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return SignatureStatusDetails__properties;
}
var SignatureStatusDetails__properties;
var SignatureStatusDetails_envelopeId;
var SignatureStatusDetails_status;
var SignatureStatusDetails_signerStatuses;
var SignatureStatusDetails_completedAt;
var SignatureStatusDetails_metadata;
function get_ScheduledAttendance__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ScheduledAttendance__properties;
}
var ScheduledAttendance__properties;
var ScheduledAttendance_time;
var ScheduledAttendance_transportFrom;
var ScheduledAttendance_transportTo;
var ScheduledAttendance_timeWhenIntermittent;
function get_ExpectedAttendance__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ExpectedAttendance__properties;
}
var ExpectedAttendance__properties;
var ExpectedAttendance_scheduled;
var ExpectedAttendance_closure;
function get_ActualAttendance__properties() {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return ActualAttendance__properties;
}
var ActualAttendance__properties;
var ActualAttendance_scheduled;
var ActualAttendance_case;
var ActualAttendance_useIntermittent;
var ActualAttendance_transportTo;
var ActualAttendance_transportFrom;
function get_submission(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_FamilyApplication_submission());
}
function get_review(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_FamilyApplication_review());
}
function get_submission_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ProviderApplication_submission());
}
function get_review_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ProviderApplication_review());
}
function get_invitedUsers(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_FamilyApplication_invitedUsers());
}
function get_invitedUsers_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ProviderApplication_invitedUsers());
}
function get_submitted(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_LocationAttendancePeriod_submitted());
}
function get_approved(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_LocationAttendancePeriod_approved());
}
function get_start(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ClosedLocalDateRange_start());
}
function get_period(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_LocationAttendancePeriod_period());
}
function get_endInclusive(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ClosedLocalDateRange_endInclusive());
}
function get_active(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ChildPlacement_active());
}
function get_endInclusive_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_LocalDateRange_endInclusive());
}
function get_activeRange(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ChildPlacement_activeRange());
}
function get_activeRange_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_FamilyEmployerAuthorization_activeRange());
}
function get_start_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_LocalDateRange_start());
}
function get_date(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareLocationClosure_date());
}
function get__id(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Employer__id());
}
function get_family(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ChildPlacement_family());
}
function get_childName(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ChildPlacement_childName());
}
function get_voided(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProviderRemittance_SingleChildDay_voided());
}
function get_family_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProviderRemittance_SingleChildDay_family());
}
function get_forDate(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProviderRemittance_SingleChildDay_forDate());
}
function get_available(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Survey_available());
}
function get_takerType(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_SurveyProgress_takerType());
}
function get_employer(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_EmployerMonthAggregates_employer());
}
function get_breakdown(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_EmployerMonthAggregates_breakdown());
}
function get_month(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_EmployerMonthAggregates_month());
}
function get_family_1(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_FamilyApplication_Submission_family());
}
function get_children(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_FamilyApplication_Submission_children());
}
function get_createdAt(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_FamilyApplication_createdAt());
}
function get_employer_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_FamilyApplication_employer());
}
function get_name(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Employer_name());
}
function get_email(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_User_email());
}
function get_managesFamilies(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_User_managesFamilies());
}
function get_email_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Parent_email());
}
function get_primaryParent(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Family_primaryParent());
}
function get_secondaryParent(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Family_secondaryParent());
}
function get__id_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Family__id());
}
function get_sentTo(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_FamilyApplication_sentTo());
}
function get_approved_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_FamilyApplication_Review_approved());
}
function get_provider(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ProviderApplication_Submission_provider());
}
function get_createdAt_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ProviderApplication_createdAt());
}
function get_managesProviders(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_User_managesProviders());
}
function get_email_1(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ContactInfo_email());
}
function get_contact(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProvider_contact());
}
function get__id_1(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProvider__id());
}
function get_sentTo_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ProviderApplication_sentTo());
}
function get_approved_1(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ProviderApplication_Review_approved());
}
function get_location(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ChildPlacement_location());
}
function get_location_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareLocationClosure_location());
}
function get_location_1(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_LocationAttendancePeriod_location());
}
function get_provider_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_LocationAttendancePeriod_provider());
}
function get_name_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareLocation_name());
}
function get__id_2(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareLocation__id());
}
function get_name_1(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProvider_name());
}
function get__id_3(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_User__id());
}
function get_location_2(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ChildAttendance_location());
}
function get_date_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ChildAttendance_date());
}
function get_location_3(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareLocationProgram_location());
}
function get_attendance(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ChildAttendance_attendance());
}
function get__id_4(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareLocationProgram__id());
}
function get_platform(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_AppRelease_platform());
}
function get_child(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ChildPlacement_child());
}
function get_birthDate(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Child_birthDate());
}
function get_gender(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Child_gender());
}
function get_active_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Child_active());
}
function get__id_5(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_FamilyEmployerAuthorization__id());
}
function get__id_6(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Grant__id());
}
function get_endReason(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ChildPlacement_endReason());
}
function get_endReasonNotes(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ChildPlacement_endReasonNotes());
}
function get_provider_1(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ChildPlacement_provider());
}
function get_lastName(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Child_lastName());
}
function get_firstName(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Child_firstName());
}
function get_family_2(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_FamilyEmployerAuthorization_family());
}
function get_name_2(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Grant_name());
}
function get_race(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Child_race());
}
function get_notes(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Child_notes());
}
function get_forDates(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProviderRemittance_forDates());
}
function get_voided_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProviderRemittance_voided());
}
function get__id_7(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ChildPlacement__id());
}
function get_careTime(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProgramTemplate_careTime());
}
function get_name_3(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProgramTemplate_name());
}
function get_template(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProgramTemplateDated_template());
}
function get_employer_1(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_EmployerRate_employer());
}
function get_activeRange_1(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_EmployerRate_activeRange());
}
function get_active_1(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Employer_active());
}
function get_at(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_EmployerAccountTransaction_at());
}
function get_voided_1(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_EmployerAccountTransaction_voided());
}
function get_employer_2(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_EmployerAccountTransaction_employer());
}
function get_reason(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_EmployerAccountTransaction_reason());
}
function get_name_4(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ContactInfo_name());
}
function get_contact_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Employer_contact());
}
function get_careProvider(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_EmployerRate_careProvider());
}
function get_administration(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_EmployerRate_administration());
}
function get_phone(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ContactInfo_phone());
}
function get_billingContactName(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Employer_billingContactName());
}
function get_billingAddress(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Employer_billingAddress());
}
function get_line1(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Address_line1());
}
function get_line2(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Address_line2());
}
function get_city(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Address_city());
}
function get_state(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Address_state());
}
function get_postalCode(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Address_postalCode());
}
function get_family_3(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Child_family());
}
function get_active_2(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Family_active());
}
function get_informationVerifiedAt(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Family_informationVerifiedAt());
}
function get_lastName_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Parent_lastName());
}
function get_firstName_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Parent_firstName());
}
function get_shortId(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Family_shortId());
}
function get_address(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Family_address());
}
function get_gender_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Parent_gender());
}
function get_birthDate_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Parent_birthDate());
}
function get_phone_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Parent_phone());
}
function get_alternatePhone(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Parent_alternatePhone());
}
function get_preferredLanguage(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Parent_preferredLanguage());
}
function get_race_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Parent_race());
}
function get_familySize(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Family_familySize());
}
function get_grant(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_GrantRate_grant());
}
function get_activeRange_2(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_GrantRate_activeRange());
}
function get_activeRange_3(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Grant_activeRange());
}
function get_at_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_GrantAccountTransaction_at());
}
function get_voided_2(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_GrantAccountTransaction_voided());
}
function get_grant_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_GrantAccountTransaction_grant());
}
function get_reason_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_GrantAccountTransaction_reason());
}
function get_funder(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Grant_funder());
}
function get_careProvider_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_GrantRate_careProvider());
}
function get_administration_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_GrantRate_administration());
}
function get_type(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareLocation_type());
}
function get_active_3(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareLocation_active());
}
function get_provider_2(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareLocation_provider());
}
function get_providerName(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareLocation_providerName());
}
function get_address_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareLocation_address());
}
function get_contact_1(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareLocation_contact());
}
function get_signedDocument(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ChildPlacement_signedDocument());
}
function get_reason_1(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareLocationClosure_reason());
}
function get_active_4(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProvider_active());
}
function get_offersTransportation(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProvider_offersTransportation());
}
function get_vendorNumber(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProvider_vendorNumber());
}
function get_availableAsIntermittent(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProgramTemplate_availableAsIntermittent());
}
function get_activeRange_4(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProgramTemplateDated_activeRange());
}
function get_shortName(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProgramTemplate_shortName());
}
function get_ageStart(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProgramTemplate_ageStart());
}
function get_ageEndInclusive(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProgramTemplate_ageEndInclusive());
}
function get_program(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareLocationProgramDated_program());
}
function get_activeRange_5(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareLocationProgramDated_activeRange());
}
function get_templateSince(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareLocationProgram_templateSince());
}
function get_template_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareLocationProgram_template());
}
function get_price(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProgramTemplateDated_price());
}
function get_transportOneWay(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProgramTemplateDated_transportOneWay());
}
function get_transportTwoWay(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProgramTemplateDated_transportTwoWay());
}
function get_remittance(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProviderRemittance_SingleChildDay_remittance());
}
function get_status(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProviderRemittance_status());
}
function get_provider_3(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProviderRemittance_provider());
}
function get_amount(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProviderRemittance_amount());
}
function get_employerContributions(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProviderRemittance_SingleChildDay_employerContributions());
}
function get_employer_3(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProviderRemittance_SingleChildDay_EmployerContribution_employer());
}
function get_grantContributions(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProviderRemittance_SingleChildDay_grantContributions());
}
function get_grant_1(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProviderRemittance_SingleChildDay_GrantContribution_grant());
}
function get_location_4(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProviderRemittance_SingleChildDay_location());
}
function get_provider_4(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_CareProviderRemittance_SingleChildDay_provider());
}
function get_employers(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ChildPlacement_employers());
}
function get_grants(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_ChildPlacement_grants());
}
function get_supportingEmployers(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_QuestionResponse_Demographic_supportingEmployers());
}
function get_demographic(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_QuestionResponse_demographic());
}
function get_takerEmployer(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_QuestionResponse_Demographic_takerEmployer());
}
function get_supportingGrants(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_QuestionResponse_Demographic_supportingGrants());
}
function get_income(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_QuestionResponse_Demographic_income());
}
function get_leadershipLevel(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_QuestionResponse_Demographic_leadershipLevel());
}
function get_city_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_QuestionResponse_Demographic_city());
}
function get_survey(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_SurveyProgress_survey());
}
function get_completedAt(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_SurveyProgress_completedAt());
}
function get_survey_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_QuestionResponse_survey());
}
function get_question(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_QuestionResponse_question());
}
function get_familySize_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_QuestionResponse_Demographic_familySize());
}
function get_takerIteration(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_QuestionResponse_takerIteration());
}
function get_answerSingleChoice(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_QuestionResponse_answerSingleChoice());
}
function get_answerMultipleChoice(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_QuestionResponse_answerMultipleChoice());
}
function get_answerScale(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_QuestionResponse_answerScale());
}
function get_answerFreeNumber(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_QuestionResponse_answerFreeNumber());
}
function get_at_1(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_QuestionResponse_at());
}
function get_name_5(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_Survey_name());
}
function get_takerId(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_SurveyProgress_takerId());
}
function get_takerIteration_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_SurveyProgress_takerIteration());
}
function get_takerId_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_QuestionResponse_takerId());
}
function get_name_6(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_User_name());
}
function get_phone_1(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_User_phone());
}
function get_preferredLanguage_0(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_User_preferredLanguage());
}
function get_active_5(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_User_active());
}
function get_role(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_User_role());
}
function get_createdAt_1(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_User_createdAt());
}
function get_managesEmployers(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_User_managesEmployers());
}
function get_managesLocations(_this__u8e3s4) {
  _init_properties_ModelFields_372156621_kt__m9qmk4();
  return _this__u8e3s4.prop(get_User_managesLocations());
}
var properties_initialized_ModelFields_372156621_kt_g00zrq;
function _init_properties_ModelFields_372156621_kt__m9qmk4() {
  if (!properties_initialized_ModelFields_372156621_kt_g00zrq) {
    properties_initialized_ModelFields_372156621_kt_g00zrq = true;
    EmployerRate__properties = ensureNotNull(get_serializableProperties(Companion_getInstance().serializer_9w0wvi_k$()));
    var tmp = get_EmployerRate__properties()[0];
    EmployerRate__id = isInterface(tmp, SerializableProperty()) ? tmp : THROW_CCE();
    var tmp_0 = get_EmployerRate__properties()[1];
    EmployerRate_employer = isInterface(tmp_0, SerializableProperty()) ? tmp_0 : THROW_CCE();
    var tmp_1 = get_EmployerRate__properties()[2];
    EmployerRate_activeRange = isInterface(tmp_1, SerializableProperty()) ? tmp_1 : THROW_CCE();
    var tmp_2 = get_EmployerRate__properties()[3];
    EmployerRate_administration = isInterface(tmp_2, SerializableProperty()) ? tmp_2 : THROW_CCE();
    var tmp_3 = get_EmployerRate__properties()[4];
    EmployerRate_careProvider = isInterface(tmp_3, SerializableProperty()) ? tmp_3 : THROW_CCE();
    GrantRate__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_0().serializer_9w0wvi_k$()));
    var tmp_4 = get_GrantRate__properties()[0];
    GrantRate__id = isInterface(tmp_4, SerializableProperty()) ? tmp_4 : THROW_CCE();
    var tmp_5 = get_GrantRate__properties()[1];
    GrantRate_grant = isInterface(tmp_5, SerializableProperty()) ? tmp_5 : THROW_CCE();
    var tmp_6 = get_GrantRate__properties()[2];
    GrantRate_activeRange = isInterface(tmp_6, SerializableProperty()) ? tmp_6 : THROW_CCE();
    var tmp_7 = get_GrantRate__properties()[3];
    GrantRate_administration = isInterface(tmp_7, SerializableProperty()) ? tmp_7 : THROW_CCE();
    var tmp_8 = get_GrantRate__properties()[4];
    GrantRate_careProvider = isInterface(tmp_8, SerializableProperty()) ? tmp_8 : THROW_CCE();
    var tmp_9 = get_GrantRate__properties()[5];
    GrantRate_eligibility = isInterface(tmp_9, SerializableProperty()) ? tmp_9 : THROW_CCE();
    CareDayInfo__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_1().serializer_9w0wvi_k$()));
    var tmp_10 = get_CareDayInfo__properties()[0];
    CareDayInfo_owed = isInterface(tmp_10, SerializableProperty()) ? tmp_10 : THROW_CCE();
    var tmp_11 = get_CareDayInfo__properties()[1];
    CareDayInfo_time = isInterface(tmp_11, SerializableProperty()) ? tmp_11 : THROW_CCE();
    var tmp_12 = get_CareDayInfo__properties()[2];
    CareDayInfo_ageMonths = isInterface(tmp_12, SerializableProperty()) ? tmp_12 : THROW_CCE();
    var tmp_13 = get_CareDayInfo__properties()[3];
    CareDayInfo_transport = isInterface(tmp_13, SerializableProperty()) ? tmp_13 : THROW_CCE();
    CareDayInfoWithEmployerSubsidy__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_2().serializer_9w0wvi_k$()));
    var tmp_14 = get_CareDayInfoWithEmployerSubsidy__properties()[0];
    CareDayInfoWithEmployerSubsidy_owed = isInterface(tmp_14, SerializableProperty()) ? tmp_14 : THROW_CCE();
    var tmp_15 = get_CareDayInfoWithEmployerSubsidy__properties()[1];
    CareDayInfoWithEmployerSubsidy_time = isInterface(tmp_15, SerializableProperty()) ? tmp_15 : THROW_CCE();
    var tmp_16 = get_CareDayInfoWithEmployerSubsidy__properties()[2];
    CareDayInfoWithEmployerSubsidy_ageMonths = isInterface(tmp_16, SerializableProperty()) ? tmp_16 : THROW_CCE();
    var tmp_17 = get_CareDayInfoWithEmployerSubsidy__properties()[3];
    CareDayInfoWithEmployerSubsidy_transport = isInterface(tmp_17, SerializableProperty()) ? tmp_17 : THROW_CCE();
    var tmp_18 = get_CareDayInfoWithEmployerSubsidy__properties()[4];
    CareDayInfoWithEmployerSubsidy_paidByEmployer = isInterface(tmp_18, SerializableProperty()) ? tmp_18 : THROW_CCE();
    CareDayInfoWithSubsidies__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_3().serializer_9w0wvi_k$()));
    var tmp_19 = get_CareDayInfoWithSubsidies__properties()[0];
    CareDayInfoWithSubsidies_owed = isInterface(tmp_19, SerializableProperty()) ? tmp_19 : THROW_CCE();
    var tmp_20 = get_CareDayInfoWithSubsidies__properties()[1];
    CareDayInfoWithSubsidies_time = isInterface(tmp_20, SerializableProperty()) ? tmp_20 : THROW_CCE();
    var tmp_21 = get_CareDayInfoWithSubsidies__properties()[2];
    CareDayInfoWithSubsidies_ageMonths = isInterface(tmp_21, SerializableProperty()) ? tmp_21 : THROW_CCE();
    var tmp_22 = get_CareDayInfoWithSubsidies__properties()[3];
    CareDayInfoWithSubsidies_transport = isInterface(tmp_22, SerializableProperty()) ? tmp_22 : THROW_CCE();
    var tmp_23 = get_CareDayInfoWithSubsidies__properties()[4];
    CareDayInfoWithSubsidies_paidByEmployer = isInterface(tmp_23, SerializableProperty()) ? tmp_23 : THROW_CCE();
    var tmp_24 = get_CareDayInfoWithSubsidies__properties()[5];
    CareDayInfoWithSubsidies_paidByGrant = isInterface(tmp_24, SerializableProperty()) ? tmp_24 : THROW_CCE();
    EmployerMonthAggregates__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_4().serializer_9w0wvi_k$()));
    var tmp_25 = get_EmployerMonthAggregates__properties()[0];
    EmployerMonthAggregates__id = isInterface(tmp_25, SerializableProperty()) ? tmp_25 : THROW_CCE();
    var tmp_26 = get_EmployerMonthAggregates__properties()[1];
    EmployerMonthAggregates_employer = isInterface(tmp_26, SerializableProperty()) ? tmp_26 : THROW_CCE();
    var tmp_27 = get_EmployerMonthAggregates__properties()[2];
    EmployerMonthAggregates_month = isInterface(tmp_27, SerializableProperty()) ? tmp_27 : THROW_CCE();
    var tmp_28 = get_EmployerMonthAggregates__properties()[3];
    EmployerMonthAggregates_breakdown = isInterface(tmp_28, SerializableProperty()) ? tmp_28 : THROW_CCE();
    var tmp_29 = get_EmployerMonthAggregates__properties()[4];
    EmployerMonthAggregates_total = isInterface(tmp_29, SerializableProperty()) ? tmp_29 : THROW_CCE();
    var tmp_30 = get_EmployerMonthAggregates__properties()[5];
    EmployerMonthAggregates_byAgeGroup = isInterface(tmp_30, SerializableProperty()) ? tmp_30 : THROW_CCE();
    var tmp_31 = get_EmployerMonthAggregates__properties()[6];
    EmployerMonthAggregates_byProviderType = isInterface(tmp_31, SerializableProperty()) ? tmp_31 : THROW_CCE();
    EmployerMonthAggregates_Stats__properties = ensureNotNull(get_serializableProperties(Companion_instance.serializer_9w0wvi_k$()));
    var tmp_32 = get_EmployerMonthAggregates_Stats__properties()[0];
    EmployerMonthAggregates_Stats_childPlacements = isInterface(tmp_32, SerializableProperty()) ? tmp_32 : THROW_CCE();
    var tmp_33 = get_EmployerMonthAggregates_Stats__properties()[1];
    EmployerMonthAggregates_Stats_children = isInterface(tmp_33, SerializableProperty()) ? tmp_33 : THROW_CCE();
    var tmp_34 = get_EmployerMonthAggregates_Stats__properties()[2];
    EmployerMonthAggregates_Stats_families = isInterface(tmp_34, SerializableProperty()) ? tmp_34 : THROW_CCE();
    EmployerMonthAggregates_MoneyBreakdown__properties = ensureNotNull(get_serializableProperties(Companion_instance_0.serializer_9w0wvi_k$()));
    var tmp_35 = get_EmployerMonthAggregates_MoneyBreakdown__properties()[0];
    EmployerMonthAggregates_MoneyBreakdown_totalCostOfCare = isInterface(tmp_35, SerializableProperty()) ? tmp_35 : THROW_CCE();
    var tmp_36 = get_EmployerMonthAggregates_MoneyBreakdown__properties()[1];
    EmployerMonthAggregates_MoneyBreakdown_employerShare = isInterface(tmp_36, SerializableProperty()) ? tmp_36 : THROW_CCE();
    var tmp_37 = get_EmployerMonthAggregates_MoneyBreakdown__properties()[2];
    EmployerMonthAggregates_MoneyBreakdown_employerAdministrationFee = isInterface(tmp_37, SerializableProperty()) ? tmp_37 : THROW_CCE();
    var tmp_38 = get_EmployerMonthAggregates_MoneyBreakdown__properties()[3];
    EmployerMonthAggregates_MoneyBreakdown_grantMatch = isInterface(tmp_38, SerializableProperty()) ? tmp_38 : THROW_CCE();
    TCGNotification__properties = ensureNotNull(get_serializableProperties(Companion_instance_1.serializer_9w0wvi_k$()));
    var tmp_39 = get_TCGNotification__properties()[0];
    TCGNotification_subject = isInterface(tmp_39, SerializableProperty()) ? tmp_39 : THROW_CCE();
    var tmp_40 = get_TCGNotification__properties()[1];
    TCGNotification_body = isInterface(tmp_40, SerializableProperty()) ? tmp_40 : THROW_CCE();
    var tmp_41 = get_TCGNotification__properties()[2];
    TCGNotification_url = isInterface(tmp_41, SerializableProperty()) ? tmp_41 : THROW_CCE();
    AccountingSyncInfo__properties = ensureNotNull(get_serializableProperties(Companion_instance_2.serializer_9w0wvi_k$()));
    var tmp_42 = get_AccountingSyncInfo__properties()[0];
    AccountingSyncInfo_lastSync = isInterface(tmp_42, SerializableProperty()) ? tmp_42 : THROW_CCE();
    var tmp_43 = get_AccountingSyncInfo__properties()[1];
    AccountingSyncInfo_documentNumber = isInterface(tmp_43, SerializableProperty()) ? tmp_43 : THROW_CCE();
    var tmp_44 = get_AccountingSyncInfo__properties()[2];
    AccountingSyncInfo_foreignId = isInterface(tmp_44, SerializableProperty()) ? tmp_44 : THROW_CCE();
    var tmp_45 = get_AccountingSyncInfo__properties()[3];
    AccountingSyncInfo_reversedBy = isInterface(tmp_45, SerializableProperty()) ? tmp_45 : THROW_CCE();
    AccountingSyncInfo_LastSync__properties = ensureNotNull(get_serializableProperties(Companion_instance_3.serializer_9w0wvi_k$()));
    var tmp_46 = get_AccountingSyncInfo_LastSync__properties()[0];
    AccountingSyncInfo_LastSync_at = isInterface(tmp_46, SerializableProperty()) ? tmp_46 : THROW_CCE();
    var tmp_47 = get_AccountingSyncInfo_LastSync__properties()[1];
    AccountingSyncInfo_LastSync_issue = isInterface(tmp_47, SerializableProperty()) ? tmp_47 : THROW_CCE();
    var tmp_48 = get_AccountingSyncInfo_LastSync__properties()[2];
    AccountingSyncInfo_LastSync_shouldContinueSyncing = isInterface(tmp_48, SerializableProperty()) ? tmp_48 : THROW_CCE();
    AccountState__properties = ensureNotNull(get_serializableProperties(Companion_instance_4.serializer_9w0wvi_k$()));
    var tmp_49 = get_AccountState__properties()[0];
    AccountState_at = isInterface(tmp_49, SerializableProperty()) ? tmp_49 : THROW_CCE();
    var tmp_50 = get_AccountState__properties()[1];
    AccountState_balance = isInterface(tmp_50, SerializableProperty()) ? tmp_50 : THROW_CCE();
    GrantAccountTransaction__properties = ensureNotNull(get_serializableProperties(Companion_instance_5.serializer_9w0wvi_k$()));
    var tmp_51 = get_GrantAccountTransaction__properties()[0];
    GrantAccountTransaction__id = isInterface(tmp_51, SerializableProperty()) ? tmp_51 : THROW_CCE();
    var tmp_52 = get_GrantAccountTransaction__properties()[1];
    GrantAccountTransaction_grant = isInterface(tmp_52, SerializableProperty()) ? tmp_52 : THROW_CCE();
    var tmp_53 = get_GrantAccountTransaction__properties()[2];
    GrantAccountTransaction_amount = isInterface(tmp_53, SerializableProperty()) ? tmp_53 : THROW_CCE();
    var tmp_54 = get_GrantAccountTransaction__properties()[3];
    GrantAccountTransaction_at = isInterface(tmp_54, SerializableProperty()) ? tmp_54 : THROW_CCE();
    var tmp_55 = get_GrantAccountTransaction__properties()[4];
    GrantAccountTransaction_reason = isInterface(tmp_55, SerializableProperty()) ? tmp_55 : THROW_CCE();
    var tmp_56 = get_GrantAccountTransaction__properties()[5];
    GrantAccountTransaction_pulledFrom = isInterface(tmp_56, SerializableProperty()) ? tmp_56 : THROW_CCE();
    var tmp_57 = get_GrantAccountTransaction__properties()[6];
    GrantAccountTransaction_voided = isInterface(tmp_57, SerializableProperty()) ? tmp_57 : THROW_CCE();
    EmployerAccountTransaction__properties = ensureNotNull(get_serializableProperties(Companion_instance_6.serializer_9w0wvi_k$()));
    var tmp_58 = get_EmployerAccountTransaction__properties()[0];
    EmployerAccountTransaction__id = isInterface(tmp_58, SerializableProperty()) ? tmp_58 : THROW_CCE();
    var tmp_59 = get_EmployerAccountTransaction__properties()[1];
    EmployerAccountTransaction_employer = isInterface(tmp_59, SerializableProperty()) ? tmp_59 : THROW_CCE();
    var tmp_60 = get_EmployerAccountTransaction__properties()[2];
    EmployerAccountTransaction_amount = isInterface(tmp_60, SerializableProperty()) ? tmp_60 : THROW_CCE();
    var tmp_61 = get_EmployerAccountTransaction__properties()[3];
    EmployerAccountTransaction_at = isInterface(tmp_61, SerializableProperty()) ? tmp_61 : THROW_CCE();
    var tmp_62 = get_EmployerAccountTransaction__properties()[4];
    EmployerAccountTransaction_reason = isInterface(tmp_62, SerializableProperty()) ? tmp_62 : THROW_CCE();
    var tmp_63 = get_EmployerAccountTransaction__properties()[5];
    EmployerAccountTransaction_pulledFrom = isInterface(tmp_63, SerializableProperty()) ? tmp_63 : THROW_CCE();
    var tmp_64 = get_EmployerAccountTransaction__properties()[6];
    EmployerAccountTransaction_voided = isInterface(tmp_64, SerializableProperty()) ? tmp_64 : THROW_CCE();
    CareProviderRemittance__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_5().serializer_9w0wvi_k$()));
    var tmp_65 = get_CareProviderRemittance__properties()[0];
    CareProviderRemittance__id = isInterface(tmp_65, SerializableProperty()) ? tmp_65 : THROW_CCE();
    var tmp_66 = get_CareProviderRemittance__properties()[1];
    CareProviderRemittance_provider = isInterface(tmp_66, SerializableProperty()) ? tmp_66 : THROW_CCE();
    var tmp_67 = get_CareProviderRemittance__properties()[2];
    CareProviderRemittance_forDates = isInterface(tmp_67, SerializableProperty()) ? tmp_67 : THROW_CCE();
    var tmp_68 = get_CareProviderRemittance__properties()[3];
    CareProviderRemittance_at = isInterface(tmp_68, SerializableProperty()) ? tmp_68 : THROW_CCE();
    var tmp_69 = get_CareProviderRemittance__properties()[4];
    CareProviderRemittance_amount = isInterface(tmp_69, SerializableProperty()) ? tmp_69 : THROW_CCE();
    var tmp_70 = get_CareProviderRemittance__properties()[5];
    CareProviderRemittance_status = isInterface(tmp_70, SerializableProperty()) ? tmp_70 : THROW_CCE();
    var tmp_71 = get_CareProviderRemittance__properties()[6];
    CareProviderRemittance_voided = isInterface(tmp_71, SerializableProperty()) ? tmp_71 : THROW_CCE();
    var tmp_72 = get_CareProviderRemittance__properties()[7];
    CareProviderRemittance_sync = isInterface(tmp_72, SerializableProperty()) ? tmp_72 : THROW_CCE();
    CareProviderRemittance_SingleChildDay__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_6().serializer_9w0wvi_k$()));
    var tmp_73 = get_CareProviderRemittance_SingleChildDay__properties()[0];
    CareProviderRemittance_SingleChildDay__id = isInterface(tmp_73, SerializableProperty()) ? tmp_73 : THROW_CCE();
    var tmp_74 = get_CareProviderRemittance_SingleChildDay__properties()[1];
    CareProviderRemittance_SingleChildDay_remittance = isInterface(tmp_74, SerializableProperty()) ? tmp_74 : THROW_CCE();
    var tmp_75 = get_CareProviderRemittance_SingleChildDay__properties()[2];
    CareProviderRemittance_SingleChildDay_placement = isInterface(tmp_75, SerializableProperty()) ? tmp_75 : THROW_CCE();
    var tmp_76 = get_CareProviderRemittance_SingleChildDay__properties()[3];
    CareProviderRemittance_SingleChildDay_family = isInterface(tmp_76, SerializableProperty()) ? tmp_76 : THROW_CCE();
    var tmp_77 = get_CareProviderRemittance_SingleChildDay__properties()[4];
    CareProviderRemittance_SingleChildDay_location = isInterface(tmp_77, SerializableProperty()) ? tmp_77 : THROW_CCE();
    var tmp_78 = get_CareProviderRemittance_SingleChildDay__properties()[5];
    CareProviderRemittance_SingleChildDay_provider = isInterface(tmp_78, SerializableProperty()) ? tmp_78 : THROW_CCE();
    var tmp_79 = get_CareProviderRemittance_SingleChildDay__properties()[6];
    CareProviderRemittance_SingleChildDay_program = isInterface(tmp_79, SerializableProperty()) ? tmp_79 : THROW_CCE();
    var tmp_80 = get_CareProviderRemittance_SingleChildDay__properties()[7];
    CareProviderRemittance_SingleChildDay_forDate = isInterface(tmp_80, SerializableProperty()) ? tmp_80 : THROW_CCE();
    var tmp_81 = get_CareProviderRemittance_SingleChildDay__properties()[8];
    CareProviderRemittance_SingleChildDay_price = isInterface(tmp_81, SerializableProperty()) ? tmp_81 : THROW_CCE();
    var tmp_82 = get_CareProviderRemittance_SingleChildDay__properties()[9];
    CareProviderRemittance_SingleChildDay_grantContributions = isInterface(tmp_82, SerializableProperty()) ? tmp_82 : THROW_CCE();
    var tmp_83 = get_CareProviderRemittance_SingleChildDay__properties()[10];
    CareProviderRemittance_SingleChildDay_employerContributions = isInterface(tmp_83, SerializableProperty()) ? tmp_83 : THROW_CCE();
    var tmp_84 = get_CareProviderRemittance_SingleChildDay__properties()[11];
    CareProviderRemittance_SingleChildDay_totalContributions = isInterface(tmp_84, SerializableProperty()) ? tmp_84 : THROW_CCE();
    var tmp_85 = get_CareProviderRemittance_SingleChildDay__properties()[12];
    CareProviderRemittance_SingleChildDay_paidByFamily = isInterface(tmp_85, SerializableProperty()) ? tmp_85 : THROW_CCE();
    var tmp_86 = get_CareProviderRemittance_SingleChildDay__properties()[13];
    CareProviderRemittance_SingleChildDay_attendance = isInterface(tmp_86, SerializableProperty()) ? tmp_86 : THROW_CCE();
    var tmp_87 = get_CareProviderRemittance_SingleChildDay__properties()[14];
    CareProviderRemittance_SingleChildDay_voided = isInterface(tmp_87, SerializableProperty()) ? tmp_87 : THROW_CCE();
    CareProviderRemittance_SingleChildDay_GrantContribution__properties = ensureNotNull(get_serializableProperties(Companion_instance_7.serializer_9w0wvi_k$()));
    var tmp_88 = get_CareProviderRemittance_SingleChildDay_GrantContribution__properties()[0];
    CareProviderRemittance_SingleChildDay_GrantContribution_grant = isInterface(tmp_88, SerializableProperty()) ? tmp_88 : THROW_CCE();
    var tmp_89 = get_CareProviderRemittance_SingleChildDay_GrantContribution__properties()[1];
    CareProviderRemittance_SingleChildDay_GrantContribution_amount = isInterface(tmp_89, SerializableProperty()) ? tmp_89 : THROW_CCE();
    var tmp_90 = get_CareProviderRemittance_SingleChildDay_GrantContribution__properties()[2];
    CareProviderRemittance_SingleChildDay_GrantContribution_administrativeCharge = isInterface(tmp_90, SerializableProperty()) ? tmp_90 : THROW_CCE();
    CareProviderRemittance_SingleChildDay_EmployerContribution__properties = ensureNotNull(get_serializableProperties(Companion_instance_8.serializer_9w0wvi_k$()));
    var tmp_91 = get_CareProviderRemittance_SingleChildDay_EmployerContribution__properties()[0];
    CareProviderRemittance_SingleChildDay_EmployerContribution_employer = isInterface(tmp_91, SerializableProperty()) ? tmp_91 : THROW_CCE();
    var tmp_92 = get_CareProviderRemittance_SingleChildDay_EmployerContribution__properties()[1];
    CareProviderRemittance_SingleChildDay_EmployerContribution_amount = isInterface(tmp_92, SerializableProperty()) ? tmp_92 : THROW_CCE();
    var tmp_93 = get_CareProviderRemittance_SingleChildDay_EmployerContribution__properties()[2];
    CareProviderRemittance_SingleChildDay_EmployerContribution_administrativeCharge = isInterface(tmp_93, SerializableProperty()) ? tmp_93 : THROW_CCE();
    DynamicSettings__properties = ensureNotNull(get_serializableProperties(Companion_instance_9.serializer_9w0wvi_k$()));
    var tmp_94 = get_DynamicSettings__properties()[0];
    DynamicSettings__id = isInterface(tmp_94, SerializableProperty()) ? tmp_94 : THROW_CCE();
    var tmp_95 = get_DynamicSettings__properties()[1];
    DynamicSettings_placementAgreementTemplate = isInterface(tmp_95, SerializableProperty()) ? tmp_95 : THROW_CCE();
    var tmp_96 = get_DynamicSettings__properties()[2];
    DynamicSettings_placementAgreementSubject = isInterface(tmp_96, SerializableProperty()) ? tmp_96 : THROW_CCE();
    var tmp_97 = get_DynamicSettings__properties()[3];
    DynamicSettings_placementAgreementMessage = isInterface(tmp_97, SerializableProperty()) ? tmp_97 : THROW_CCE();
    var tmp_98 = get_DynamicSettings__properties()[4];
    DynamicSettings_employerAgreementTemplate = isInterface(tmp_98, SerializableProperty()) ? tmp_98 : THROW_CCE();
    var tmp_99 = get_DynamicSettings__properties()[5];
    DynamicSettings_employerAgreementSubject = isInterface(tmp_99, SerializableProperty()) ? tmp_99 : THROW_CCE();
    var tmp_100 = get_DynamicSettings__properties()[6];
    DynamicSettings_employerAgreementMessage = isInterface(tmp_100, SerializableProperty()) ? tmp_100 : THROW_CCE();
    var tmp_101 = get_DynamicSettings__properties()[7];
    DynamicSettings_tcgSigner = isInterface(tmp_101, SerializableProperty()) ? tmp_101 : THROW_CCE();
    AppRelease__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_7().serializer_9w0wvi_k$()));
    var tmp_102 = get_AppRelease__properties()[0];
    AppRelease__id = isInterface(tmp_102, SerializableProperty()) ? tmp_102 : THROW_CCE();
    var tmp_103 = get_AppRelease__properties()[1];
    AppRelease_version = isInterface(tmp_103, SerializableProperty()) ? tmp_103 : THROW_CCE();
    var tmp_104 = get_AppRelease__properties()[2];
    AppRelease_platform = isInterface(tmp_104, SerializableProperty()) ? tmp_104 : THROW_CCE();
    var tmp_105 = get_AppRelease__properties()[3];
    AppRelease_releaseDate = isInterface(tmp_105, SerializableProperty()) ? tmp_105 : THROW_CCE();
    var tmp_106 = get_AppRelease__properties()[4];
    AppRelease_requiredUpdate = isInterface(tmp_106, SerializableProperty()) ? tmp_106 : THROW_CCE();
    User__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_8().serializer_9w0wvi_k$()));
    var tmp_107 = get_User__properties()[0];
    User__id = isInterface(tmp_107, SerializableProperty()) ? tmp_107 : THROW_CCE();
    var tmp_108 = get_User__properties()[1];
    User_email = isInterface(tmp_108, SerializableProperty()) ? tmp_108 : THROW_CCE();
    var tmp_109 = get_User__properties()[2];
    User_name = isInterface(tmp_109, SerializableProperty()) ? tmp_109 : THROW_CCE();
    var tmp_110 = get_User__properties()[3];
    User_phone = isInterface(tmp_110, SerializableProperty()) ? tmp_110 : THROW_CCE();
    var tmp_111 = get_User__properties()[4];
    User_preferredLanguage = isInterface(tmp_111, SerializableProperty()) ? tmp_111 : THROW_CCE();
    var tmp_112 = get_User__properties()[5];
    User_role = isInterface(tmp_112, SerializableProperty()) ? tmp_112 : THROW_CCE();
    var tmp_113 = get_User__properties()[6];
    User_managesEmployers = isInterface(tmp_113, SerializableProperty()) ? tmp_113 : THROW_CCE();
    var tmp_114 = get_User__properties()[7];
    User_managesProviders = isInterface(tmp_114, SerializableProperty()) ? tmp_114 : THROW_CCE();
    var tmp_115 = get_User__properties()[8];
    User_managesLocations = isInterface(tmp_115, SerializableProperty()) ? tmp_115 : THROW_CCE();
    var tmp_116 = get_User__properties()[9];
    User_managesFamilies = isInterface(tmp_116, SerializableProperty()) ? tmp_116 : THROW_CCE();
    var tmp_117 = get_User__properties()[10];
    User_createdAt = isInterface(tmp_117, SerializableProperty()) ? tmp_117 : THROW_CCE();
    var tmp_118 = get_User__properties()[11];
    User_updatedAt = isInterface(tmp_118, SerializableProperty()) ? tmp_118 : THROW_CCE();
    var tmp_119 = get_User__properties()[12];
    User_active = isInterface(tmp_119, SerializableProperty()) ? tmp_119 : THROW_CCE();
    FcmToken__properties = ensureNotNull(get_serializableProperties(Companion_instance_10.serializer_9w0wvi_k$()));
    var tmp_120 = get_FcmToken__properties()[0];
    FcmToken__id = isInterface(tmp_120, SerializableProperty()) ? tmp_120 : THROW_CCE();
    var tmp_121 = get_FcmToken__properties()[1];
    FcmToken_user = isInterface(tmp_121, SerializableProperty()) ? tmp_121 : THROW_CCE();
    var tmp_122 = get_FcmToken__properties()[2];
    FcmToken_active = isInterface(tmp_122, SerializableProperty()) ? tmp_122 : THROW_CCE();
    var tmp_123 = get_FcmToken__properties()[3];
    FcmToken_created = isInterface(tmp_123, SerializableProperty()) ? tmp_123 : THROW_CCE();
    var tmp_124 = get_FcmToken__properties()[4];
    FcmToken_lastRegisteredAt = isInterface(tmp_124, SerializableProperty()) ? tmp_124 : THROW_CCE();
    var tmp_125 = get_FcmToken__properties()[5];
    FcmToken_userAgent = isInterface(tmp_125, SerializableProperty()) ? tmp_125 : THROW_CCE();
    ClosedLocalDateRange__properties = ensureNotNull(get_serializableProperties(Companion_instance_11.serializer_9w0wvi_k$()));
    var tmp_126 = get_ClosedLocalDateRange__properties()[0];
    ClosedLocalDateRange_start = isInterface(tmp_126, SerializableProperty()) ? tmp_126 : THROW_CCE();
    var tmp_127 = get_ClosedLocalDateRange__properties()[1];
    ClosedLocalDateRange_endInclusive = isInterface(tmp_127, SerializableProperty()) ? tmp_127 : THROW_CCE();
    LocalDateRange__properties = ensureNotNull(get_serializableProperties(Companion_instance_12.serializer_9w0wvi_k$()));
    var tmp_128 = get_LocalDateRange__properties()[0];
    LocalDateRange_start = isInterface(tmp_128, SerializableProperty()) ? tmp_128 : THROW_CCE();
    var tmp_129 = get_LocalDateRange__properties()[1];
    LocalDateRange_endInclusive = isInterface(tmp_129, SerializableProperty()) ? tmp_129 : THROW_CCE();
    RecordedAction__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_9().serializer_9w0wvi_k$()));
    var tmp_130 = get_RecordedAction__properties()[0];
    RecordedAction_by = isInterface(tmp_130, SerializableProperty()) ? tmp_130 : THROW_CCE();
    var tmp_131 = get_RecordedAction__properties()[1];
    RecordedAction_at = isInterface(tmp_131, SerializableProperty()) ? tmp_131 : THROW_CCE();
    var tmp_132 = get_RecordedAction__properties()[2];
    RecordedAction_reason = isInterface(tmp_132, SerializableProperty()) ? tmp_132 : THROW_CCE();
    ContactInfo__properties = ensureNotNull(get_serializableProperties(Companion_instance_13.serializer_9w0wvi_k$()));
    var tmp_133 = get_ContactInfo__properties()[0];
    ContactInfo_name = isInterface(tmp_133, SerializableProperty()) ? tmp_133 : THROW_CCE();
    var tmp_134 = get_ContactInfo__properties()[1];
    ContactInfo_email = isInterface(tmp_134, SerializableProperty()) ? tmp_134 : THROW_CCE();
    var tmp_135 = get_ContactInfo__properties()[2];
    ContactInfo_phone = isInterface(tmp_135, SerializableProperty()) ? tmp_135 : THROW_CCE();
    Address__properties = ensureNotNull(get_serializableProperties(Companion_instance_14.serializer_9w0wvi_k$()));
    var tmp_136 = get_Address__properties()[0];
    Address_line1 = isInterface(tmp_136, SerializableProperty()) ? tmp_136 : THROW_CCE();
    var tmp_137 = get_Address__properties()[1];
    Address_line2 = isInterface(tmp_137, SerializableProperty()) ? tmp_137 : THROW_CCE();
    var tmp_138 = get_Address__properties()[2];
    Address_city = isInterface(tmp_138, SerializableProperty()) ? tmp_138 : THROW_CCE();
    var tmp_139 = get_Address__properties()[3];
    Address_state = isInterface(tmp_139, SerializableProperty()) ? tmp_139 : THROW_CCE();
    var tmp_140 = get_Address__properties()[4];
    Address_postalCode = isInterface(tmp_140, SerializableProperty()) ? tmp_140 : THROW_CCE();
    var tmp_141 = get_Address__properties()[5];
    Address_geo = isInterface(tmp_141, SerializableProperty()) ? tmp_141 : THROW_CCE();
    Family__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_10().serializer_9w0wvi_k$()));
    var tmp_142 = get_Family__properties()[0];
    Family__id = isInterface(tmp_142, SerializableProperty()) ? tmp_142 : THROW_CCE();
    var tmp_143 = get_Family__properties()[1];
    Family_shortId = isInterface(tmp_143, SerializableProperty()) ? tmp_143 : THROW_CCE();
    var tmp_144 = get_Family__properties()[2];
    Family_primaryParent = isInterface(tmp_144, SerializableProperty()) ? tmp_144 : THROW_CCE();
    var tmp_145 = get_Family__properties()[3];
    Family_secondaryParent = isInterface(tmp_145, SerializableProperty()) ? tmp_145 : THROW_CCE();
    var tmp_146 = get_Family__properties()[4];
    Family_childNames = isInterface(tmp_146, SerializableProperty()) ? tmp_146 : THROW_CCE();
    var tmp_147 = get_Family__properties()[5];
    Family_income = isInterface(tmp_147, SerializableProperty()) ? tmp_147 : THROW_CCE();
    var tmp_148 = get_Family__properties()[6];
    Family_familySize = isInterface(tmp_148, SerializableProperty()) ? tmp_148 : THROW_CCE();
    var tmp_149 = get_Family__properties()[7];
    Family_address = isInterface(tmp_149, SerializableProperty()) ? tmp_149 : THROW_CCE();
    var tmp_150 = get_Family__properties()[8];
    Family_mailingAddress = isInterface(tmp_150, SerializableProperty()) ? tmp_150 : THROW_CCE();
    var tmp_151 = get_Family__properties()[9];
    Family_informationVerifiedAt = isInterface(tmp_151, SerializableProperty()) ? tmp_151 : THROW_CCE();
    var tmp_152 = get_Family__properties()[10];
    Family_active = isInterface(tmp_152, SerializableProperty()) ? tmp_152 : THROW_CCE();
    FamilyEmployerAuthorization__properties = ensureNotNull(get_serializableProperties(Companion_instance_15.serializer_9w0wvi_k$()));
    var tmp_153 = get_FamilyEmployerAuthorization__properties()[0];
    FamilyEmployerAuthorization__id = isInterface(tmp_153, SerializableProperty()) ? tmp_153 : THROW_CCE();
    var tmp_154 = get_FamilyEmployerAuthorization__properties()[1];
    FamilyEmployerAuthorization_family = isInterface(tmp_154, SerializableProperty()) ? tmp_154 : THROW_CCE();
    var tmp_155 = get_FamilyEmployerAuthorization__properties()[2];
    FamilyEmployerAuthorization_employer = isInterface(tmp_155, SerializableProperty()) ? tmp_155 : THROW_CCE();
    var tmp_156 = get_FamilyEmployerAuthorization__properties()[3];
    FamilyEmployerAuthorization_activeRange = isInterface(tmp_156, SerializableProperty()) ? tmp_156 : THROW_CCE();
    Parent__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_11().serializer_9w0wvi_k$()));
    var tmp_157 = get_Parent__properties()[0];
    Parent_firstName = isInterface(tmp_157, SerializableProperty()) ? tmp_157 : THROW_CCE();
    var tmp_158 = get_Parent__properties()[1];
    Parent_lastName = isInterface(tmp_158, SerializableProperty()) ? tmp_158 : THROW_CCE();
    var tmp_159 = get_Parent__properties()[2];
    Parent_email = isInterface(tmp_159, SerializableProperty()) ? tmp_159 : THROW_CCE();
    var tmp_160 = get_Parent__properties()[3];
    Parent_phone = isInterface(tmp_160, SerializableProperty()) ? tmp_160 : THROW_CCE();
    var tmp_161 = get_Parent__properties()[4];
    Parent_alternatePhone = isInterface(tmp_161, SerializableProperty()) ? tmp_161 : THROW_CCE();
    var tmp_162 = get_Parent__properties()[5];
    Parent_preferredLanguage = isInterface(tmp_162, SerializableProperty()) ? tmp_162 : THROW_CCE();
    var tmp_163 = get_Parent__properties()[6];
    Parent_race = isInterface(tmp_163, SerializableProperty()) ? tmp_163 : THROW_CCE();
    var tmp_164 = get_Parent__properties()[7];
    Parent_gender = isInterface(tmp_164, SerializableProperty()) ? tmp_164 : THROW_CCE();
    var tmp_165 = get_Parent__properties()[8];
    Parent_birthDate = isInterface(tmp_165, SerializableProperty()) ? tmp_165 : THROW_CCE();
    IncomeRange__properties = ensureNotNull(get_serializableProperties(Companion_instance_16.serializer_9w0wvi_k$()));
    var tmp_166 = get_IncomeRange__properties()[0];
    IncomeRange_min = isInterface(tmp_166, SerializableProperty()) ? tmp_166 : THROW_CCE();
    var tmp_167 = get_IncomeRange__properties()[1];
    IncomeRange_max = isInterface(tmp_167, SerializableProperty()) ? tmp_167 : THROW_CCE();
    Child__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_12().serializer_9w0wvi_k$()));
    var tmp_168 = get_Child__properties()[0];
    Child__id = isInterface(tmp_168, SerializableProperty()) ? tmp_168 : THROW_CCE();
    var tmp_169 = get_Child__properties()[1];
    Child_family = isInterface(tmp_169, SerializableProperty()) ? tmp_169 : THROW_CCE();
    var tmp_170 = get_Child__properties()[2];
    Child_firstName = isInterface(tmp_170, SerializableProperty()) ? tmp_170 : THROW_CCE();
    var tmp_171 = get_Child__properties()[3];
    Child_lastName = isInterface(tmp_171, SerializableProperty()) ? tmp_171 : THROW_CCE();
    var tmp_172 = get_Child__properties()[4];
    Child_birthDate = isInterface(tmp_172, SerializableProperty()) ? tmp_172 : THROW_CCE();
    var tmp_173 = get_Child__properties()[5];
    Child_notes = isInterface(tmp_173, SerializableProperty()) ? tmp_173 : THROW_CCE();
    var tmp_174 = get_Child__properties()[6];
    Child_race = isInterface(tmp_174, SerializableProperty()) ? tmp_174 : THROW_CCE();
    var tmp_175 = get_Child__properties()[7];
    Child_gender = isInterface(tmp_175, SerializableProperty()) ? tmp_175 : THROW_CCE();
    var tmp_176 = get_Child__properties()[8];
    Child_active = isInterface(tmp_176, SerializableProperty()) ? tmp_176 : THROW_CCE();
    ChildPlacement__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_13().serializer_9w0wvi_k$()));
    var tmp_177 = get_ChildPlacement__properties()[0];
    ChildPlacement__id = isInterface(tmp_177, SerializableProperty()) ? tmp_177 : THROW_CCE();
    var tmp_178 = get_ChildPlacement__properties()[1];
    ChildPlacement_child = isInterface(tmp_178, SerializableProperty()) ? tmp_178 : THROW_CCE();
    var tmp_179 = get_ChildPlacement__properties()[2];
    ChildPlacement_childName = isInterface(tmp_179, SerializableProperty()) ? tmp_179 : THROW_CCE();
    var tmp_180 = get_ChildPlacement__properties()[3];
    ChildPlacement_childBirthDate = isInterface(tmp_180, SerializableProperty()) ? tmp_180 : THROW_CCE();
    var tmp_181 = get_ChildPlacement__properties()[4];
    ChildPlacement_family = isInterface(tmp_181, SerializableProperty()) ? tmp_181 : THROW_CCE();
    var tmp_182 = get_ChildPlacement__properties()[5];
    ChildPlacement_location = isInterface(tmp_182, SerializableProperty()) ? tmp_182 : THROW_CCE();
    var tmp_183 = get_ChildPlacement__properties()[6];
    ChildPlacement_provider = isInterface(tmp_183, SerializableProperty()) ? tmp_183 : THROW_CCE();
    var tmp_184 = get_ChildPlacement__properties()[7];
    ChildPlacement_authorizations = isInterface(tmp_184, SerializableProperty()) ? tmp_184 : THROW_CCE();
    var tmp_185 = get_ChildPlacement__properties()[8];
    ChildPlacement_employers = isInterface(tmp_185, SerializableProperty()) ? tmp_185 : THROW_CCE();
    var tmp_186 = get_ChildPlacement__properties()[9];
    ChildPlacement_grants = isInterface(tmp_186, SerializableProperty()) ? tmp_186 : THROW_CCE();
    var tmp_187 = get_ChildPlacement__properties()[10];
    ChildPlacement_schedule = isInterface(tmp_187, SerializableProperty()) ? tmp_187 : THROW_CCE();
    var tmp_188 = get_ChildPlacement__properties()[11];
    ChildPlacement_activeRange = isInterface(tmp_188, SerializableProperty()) ? tmp_188 : THROW_CCE();
    var tmp_189 = get_ChildPlacement__properties()[12];
    ChildPlacement_endReason = isInterface(tmp_189, SerializableProperty()) ? tmp_189 : THROW_CCE();
    var tmp_190 = get_ChildPlacement__properties()[13];
    ChildPlacement_endReasonNotes = isInterface(tmp_190, SerializableProperty()) ? tmp_190 : THROW_CCE();
    var tmp_191 = get_ChildPlacement__properties()[14];
    ChildPlacement_signingInfo = isInterface(tmp_191, SerializableProperty()) ? tmp_191 : THROW_CCE();
    var tmp_192 = get_ChildPlacement__properties()[15];
    ChildPlacement_signedDocument = isInterface(tmp_192, SerializableProperty()) ? tmp_192 : THROW_CCE();
    var tmp_193 = get_ChildPlacement__properties()[16];
    ChildPlacement_active = isInterface(tmp_193, SerializableProperty()) ? tmp_193 : THROW_CCE();
    ChildPlacement_SignedDocument__properties = ensureNotNull(get_serializableProperties(Companion_instance_17.serializer_9w0wvi_k$()));
    var tmp_194 = get_ChildPlacement_SignedDocument__properties()[0];
    ChildPlacement_SignedDocument_file = isInterface(tmp_194, SerializableProperty()) ? tmp_194 : THROW_CCE();
    var tmp_195 = get_ChildPlacement_SignedDocument__properties()[1];
    ChildPlacement_SignedDocument_at = isInterface(tmp_195, SerializableProperty()) ? tmp_195 : THROW_CCE();
    ChildPlacement_Schedule__properties = ensureNotNull(get_serializableProperties(Companion_instance_18.serializer_9w0wvi_k$()));
    var tmp_196 = get_ChildPlacement_Schedule__properties()[0];
    ChildPlacement_Schedule_monday = isInterface(tmp_196, SerializableProperty()) ? tmp_196 : THROW_CCE();
    var tmp_197 = get_ChildPlacement_Schedule__properties()[1];
    ChildPlacement_Schedule_tuesday = isInterface(tmp_197, SerializableProperty()) ? tmp_197 : THROW_CCE();
    var tmp_198 = get_ChildPlacement_Schedule__properties()[2];
    ChildPlacement_Schedule_wednesday = isInterface(tmp_198, SerializableProperty()) ? tmp_198 : THROW_CCE();
    var tmp_199 = get_ChildPlacement_Schedule__properties()[3];
    ChildPlacement_Schedule_thursday = isInterface(tmp_199, SerializableProperty()) ? tmp_199 : THROW_CCE();
    var tmp_200 = get_ChildPlacement_Schedule__properties()[4];
    ChildPlacement_Schedule_friday = isInterface(tmp_200, SerializableProperty()) ? tmp_200 : THROW_CCE();
    var tmp_201 = get_ChildPlacement_Schedule__properties()[5];
    ChildPlacement_Schedule_saturday = isInterface(tmp_201, SerializableProperty()) ? tmp_201 : THROW_CCE();
    var tmp_202 = get_ChildPlacement_Schedule__properties()[6];
    ChildPlacement_Schedule_sunday = isInterface(tmp_202, SerializableProperty()) ? tmp_202 : THROW_CCE();
    ChildPlacement_Schedule_Day__properties = ensureNotNull(get_serializableProperties(Companion_instance_19.serializer_9w0wvi_k$()));
    var tmp_203 = get_ChildPlacement_Schedule_Day__properties()[0];
    ChildPlacement_Schedule_Day_program = isInterface(tmp_203, SerializableProperty()) ? tmp_203 : THROW_CCE();
    var tmp_204 = get_ChildPlacement_Schedule_Day__properties()[1];
    ChildPlacement_Schedule_Day_transportFrom = isInterface(tmp_204, SerializableProperty()) ? tmp_204 : THROW_CCE();
    var tmp_205 = get_ChildPlacement_Schedule_Day__properties()[2];
    ChildPlacement_Schedule_Day_transportTo = isInterface(tmp_205, SerializableProperty()) ? tmp_205 : THROW_CCE();
    var tmp_206 = get_ChildPlacement_Schedule_Day__properties()[3];
    ChildPlacement_Schedule_Day_programWhenIntermittent = isInterface(tmp_206, SerializableProperty()) ? tmp_206 : THROW_CCE();
    ChildAttendance__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_14().serializer_9w0wvi_k$()));
    var tmp_207 = get_ChildAttendance__properties()[0];
    ChildAttendance__id = isInterface(tmp_207, SerializableProperty()) ? tmp_207 : THROW_CCE();
    var tmp_208 = get_ChildAttendance__properties()[1];
    ChildAttendance_placement = isInterface(tmp_208, SerializableProperty()) ? tmp_208 : THROW_CCE();
    var tmp_209 = get_ChildAttendance__properties()[2];
    ChildAttendance_child = isInterface(tmp_209, SerializableProperty()) ? tmp_209 : THROW_CCE();
    var tmp_210 = get_ChildAttendance__properties()[3];
    ChildAttendance_family = isInterface(tmp_210, SerializableProperty()) ? tmp_210 : THROW_CCE();
    var tmp_211 = get_ChildAttendance__properties()[4];
    ChildAttendance_employers = isInterface(tmp_211, SerializableProperty()) ? tmp_211 : THROW_CCE();
    var tmp_212 = get_ChildAttendance__properties()[5];
    ChildAttendance_grants = isInterface(tmp_212, SerializableProperty()) ? tmp_212 : THROW_CCE();
    var tmp_213 = get_ChildAttendance__properties()[6];
    ChildAttendance_location = isInterface(tmp_213, SerializableProperty()) ? tmp_213 : THROW_CCE();
    var tmp_214 = get_ChildAttendance__properties()[7];
    ChildAttendance_provider = isInterface(tmp_214, SerializableProperty()) ? tmp_214 : THROW_CCE();
    var tmp_215 = get_ChildAttendance__properties()[8];
    ChildAttendance_date = isInterface(tmp_215, SerializableProperty()) ? tmp_215 : THROW_CCE();
    var tmp_216 = get_ChildAttendance__properties()[9];
    ChildAttendance_attendance = isInterface(tmp_216, SerializableProperty()) ? tmp_216 : THROW_CCE();
    CareProvider__properties = ensureNotNull(get_serializableProperties(Companion_instance_20.serializer_9w0wvi_k$()));
    var tmp_217 = get_CareProvider__properties()[0];
    CareProvider__id = isInterface(tmp_217, SerializableProperty()) ? tmp_217 : THROW_CCE();
    var tmp_218 = get_CareProvider__properties()[1];
    CareProvider_name = isInterface(tmp_218, SerializableProperty()) ? tmp_218 : THROW_CCE();
    var tmp_219 = get_CareProvider__properties()[2];
    CareProvider_contact = isInterface(tmp_219, SerializableProperty()) ? tmp_219 : THROW_CCE();
    var tmp_220 = get_CareProvider__properties()[3];
    CareProvider_vendorNumber = isInterface(tmp_220, SerializableProperty()) ? tmp_220 : THROW_CCE();
    var tmp_221 = get_CareProvider__properties()[4];
    CareProvider_sync = isInterface(tmp_221, SerializableProperty()) ? tmp_221 : THROW_CCE();
    var tmp_222 = get_CareProvider__properties()[5];
    CareProvider_offersTransportation = isInterface(tmp_222, SerializableProperty()) ? tmp_222 : THROW_CCE();
    var tmp_223 = get_CareProvider__properties()[6];
    CareProvider_active = isInterface(tmp_223, SerializableProperty()) ? tmp_223 : THROW_CCE();
    CareLocation__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_15().serializer_9w0wvi_k$()));
    var tmp_224 = get_CareLocation__properties()[0];
    CareLocation__id = isInterface(tmp_224, SerializableProperty()) ? tmp_224 : THROW_CCE();
    var tmp_225 = get_CareLocation__properties()[1];
    CareLocation_provider = isInterface(tmp_225, SerializableProperty()) ? tmp_225 : THROW_CCE();
    var tmp_226 = get_CareLocation__properties()[2];
    CareLocation_providerName = isInterface(tmp_226, SerializableProperty()) ? tmp_226 : THROW_CCE();
    var tmp_227 = get_CareLocation__properties()[3];
    CareLocation_type = isInterface(tmp_227, SerializableProperty()) ? tmp_227 : THROW_CCE();
    var tmp_228 = get_CareLocation__properties()[4];
    CareLocation_name = isInterface(tmp_228, SerializableProperty()) ? tmp_228 : THROW_CCE();
    var tmp_229 = get_CareLocation__properties()[5];
    CareLocation_address = isInterface(tmp_229, SerializableProperty()) ? tmp_229 : THROW_CCE();
    var tmp_230 = get_CareLocation__properties()[6];
    CareLocation_contact = isInterface(tmp_230, SerializableProperty()) ? tmp_230 : THROW_CCE();
    var tmp_231 = get_CareLocation__properties()[7];
    CareLocation_active = isInterface(tmp_231, SerializableProperty()) ? tmp_231 : THROW_CCE();
    CareLocationClosure__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_16().serializer_9w0wvi_k$()));
    var tmp_232 = get_CareLocationClosure__properties()[0];
    CareLocationClosure__id = isInterface(tmp_232, SerializableProperty()) ? tmp_232 : THROW_CCE();
    var tmp_233 = get_CareLocationClosure__properties()[1];
    CareLocationClosure_provider = isInterface(tmp_233, SerializableProperty()) ? tmp_233 : THROW_CCE();
    var tmp_234 = get_CareLocationClosure__properties()[2];
    CareLocationClosure_location = isInterface(tmp_234, SerializableProperty()) ? tmp_234 : THROW_CCE();
    var tmp_235 = get_CareLocationClosure__properties()[3];
    CareLocationClosure_date = isInterface(tmp_235, SerializableProperty()) ? tmp_235 : THROW_CCE();
    var tmp_236 = get_CareLocationClosure__properties()[4];
    CareLocationClosure_reason = isInterface(tmp_236, SerializableProperty()) ? tmp_236 : THROW_CCE();
    var tmp_237 = get_CareLocationClosure__properties()[5];
    CareLocationClosure_submitted = isInterface(tmp_237, SerializableProperty()) ? tmp_237 : THROW_CCE();
    LocationAttendancePeriod__properties = ensureNotNull(get_serializableProperties(Companion_instance_21.serializer_9w0wvi_k$()));
    var tmp_238 = get_LocationAttendancePeriod__properties()[0];
    LocationAttendancePeriod__id = isInterface(tmp_238, SerializableProperty()) ? tmp_238 : THROW_CCE();
    var tmp_239 = get_LocationAttendancePeriod__properties()[1];
    LocationAttendancePeriod_location = isInterface(tmp_239, SerializableProperty()) ? tmp_239 : THROW_CCE();
    var tmp_240 = get_LocationAttendancePeriod__properties()[2];
    LocationAttendancePeriod_provider = isInterface(tmp_240, SerializableProperty()) ? tmp_240 : THROW_CCE();
    var tmp_241 = get_LocationAttendancePeriod__properties()[3];
    LocationAttendancePeriod_period = isInterface(tmp_241, SerializableProperty()) ? tmp_241 : THROW_CCE();
    var tmp_242 = get_LocationAttendancePeriod__properties()[4];
    LocationAttendancePeriod_submitted = isInterface(tmp_242, SerializableProperty()) ? tmp_242 : THROW_CCE();
    var tmp_243 = get_LocationAttendancePeriod__properties()[5];
    LocationAttendancePeriod_approved = isInterface(tmp_243, SerializableProperty()) ? tmp_243 : THROW_CCE();
    Employer__properties = ensureNotNull(get_serializableProperties(Companion_instance_22.serializer_9w0wvi_k$()));
    var tmp_244 = get_Employer__properties()[0];
    Employer__id = isInterface(tmp_244, SerializableProperty()) ? tmp_244 : THROW_CCE();
    var tmp_245 = get_Employer__properties()[1];
    Employer_name = isInterface(tmp_245, SerializableProperty()) ? tmp_245 : THROW_CCE();
    var tmp_246 = get_Employer__properties()[2];
    Employer_contact = isInterface(tmp_246, SerializableProperty()) ? tmp_246 : THROW_CCE();
    var tmp_247 = get_Employer__properties()[3];
    Employer_billingAddress = isInterface(tmp_247, SerializableProperty()) ? tmp_247 : THROW_CCE();
    var tmp_248 = get_Employer__properties()[4];
    Employer_billingContactName = isInterface(tmp_248, SerializableProperty()) ? tmp_248 : THROW_CCE();
    var tmp_249 = get_Employer__properties()[5];
    Employer_sync = isInterface(tmp_249, SerializableProperty()) ? tmp_249 : THROW_CCE();
    var tmp_250 = get_Employer__properties()[6];
    Employer_balance = isInterface(tmp_250, SerializableProperty()) ? tmp_250 : THROW_CCE();
    var tmp_251 = get_Employer__properties()[7];
    Employer_signingInfo = isInterface(tmp_251, SerializableProperty()) ? tmp_251 : THROW_CCE();
    var tmp_252 = get_Employer__properties()[8];
    Employer_signedDocument = isInterface(tmp_252, SerializableProperty()) ? tmp_252 : THROW_CCE();
    var tmp_253 = get_Employer__properties()[9];
    Employer_active = isInterface(tmp_253, SerializableProperty()) ? tmp_253 : THROW_CCE();
    Grant__properties = ensureNotNull(get_serializableProperties(Companion_instance_23.serializer_9w0wvi_k$()));
    var tmp_254 = get_Grant__properties()[0];
    Grant__id = isInterface(tmp_254, SerializableProperty()) ? tmp_254 : THROW_CCE();
    var tmp_255 = get_Grant__properties()[1];
    Grant_name = isInterface(tmp_255, SerializableProperty()) ? tmp_255 : THROW_CCE();
    var tmp_256 = get_Grant__properties()[2];
    Grant_funder = isInterface(tmp_256, SerializableProperty()) ? tmp_256 : THROW_CCE();
    var tmp_257 = get_Grant__properties()[3];
    Grant_activeRange = isInterface(tmp_257, SerializableProperty()) ? tmp_257 : THROW_CCE();
    var tmp_258 = get_Grant__properties()[4];
    Grant_sync = isInterface(tmp_258, SerializableProperty()) ? tmp_258 : THROW_CCE();
    var tmp_259 = get_Grant__properties()[5];
    Grant_balance = isInterface(tmp_259, SerializableProperty()) ? tmp_259 : THROW_CCE();
    FamilyApplication__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_17().serializer_9w0wvi_k$()));
    var tmp_260 = get_FamilyApplication__properties()[0];
    FamilyApplication__id = isInterface(tmp_260, SerializableProperty()) ? tmp_260 : THROW_CCE();
    var tmp_261 = get_FamilyApplication__properties()[1];
    FamilyApplication_employer = isInterface(tmp_261, SerializableProperty()) ? tmp_261 : THROW_CCE();
    var tmp_262 = get_FamilyApplication__properties()[2];
    FamilyApplication_sentTo = isInterface(tmp_262, SerializableProperty()) ? tmp_262 : THROW_CCE();
    var tmp_263 = get_FamilyApplication__properties()[3];
    FamilyApplication_createdAt = isInterface(tmp_263, SerializableProperty()) ? tmp_263 : THROW_CCE();
    var tmp_264 = get_FamilyApplication__properties()[4];
    FamilyApplication_invitedUsers = isInterface(tmp_264, SerializableProperty()) ? tmp_264 : THROW_CCE();
    var tmp_265 = get_FamilyApplication__properties()[5];
    FamilyApplication_submission = isInterface(tmp_265, SerializableProperty()) ? tmp_265 : THROW_CCE();
    var tmp_266 = get_FamilyApplication__properties()[6];
    FamilyApplication_review = isInterface(tmp_266, SerializableProperty()) ? tmp_266 : THROW_CCE();
    FamilyApplication_Submission__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_18().serializer_9w0wvi_k$()));
    var tmp_267 = get_FamilyApplication_Submission__properties()[0];
    FamilyApplication_Submission_submittedAt = isInterface(tmp_267, SerializableProperty()) ? tmp_267 : THROW_CCE();
    var tmp_268 = get_FamilyApplication_Submission__properties()[1];
    FamilyApplication_Submission_family = isInterface(tmp_268, SerializableProperty()) ? tmp_268 : THROW_CCE();
    var tmp_269 = get_FamilyApplication_Submission__properties()[2];
    FamilyApplication_Submission_children = isInterface(tmp_269, SerializableProperty()) ? tmp_269 : THROW_CCE();
    FamilyApplication_Review__properties = ensureNotNull(get_serializableProperties(Companion_instance_24.serializer_9w0wvi_k$()));
    var tmp_270 = get_FamilyApplication_Review__properties()[0];
    FamilyApplication_Review_reviewedAt = isInterface(tmp_270, SerializableProperty()) ? tmp_270 : THROW_CCE();
    var tmp_271 = get_FamilyApplication_Review__properties()[1];
    FamilyApplication_Review_approved = isInterface(tmp_271, SerializableProperty()) ? tmp_271 : THROW_CCE();
    var tmp_272 = get_FamilyApplication_Review__properties()[2];
    FamilyApplication_Review_resultingFamily = isInterface(tmp_272, SerializableProperty()) ? tmp_272 : THROW_CCE();
    ProviderApplication__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_19().serializer_9w0wvi_k$()));
    var tmp_273 = get_ProviderApplication__properties()[0];
    ProviderApplication__id = isInterface(tmp_273, SerializableProperty()) ? tmp_273 : THROW_CCE();
    var tmp_274 = get_ProviderApplication__properties()[1];
    ProviderApplication_sentTo = isInterface(tmp_274, SerializableProperty()) ? tmp_274 : THROW_CCE();
    var tmp_275 = get_ProviderApplication__properties()[2];
    ProviderApplication_createdAt = isInterface(tmp_275, SerializableProperty()) ? tmp_275 : THROW_CCE();
    var tmp_276 = get_ProviderApplication__properties()[3];
    ProviderApplication_invitedUsers = isInterface(tmp_276, SerializableProperty()) ? tmp_276 : THROW_CCE();
    var tmp_277 = get_ProviderApplication__properties()[4];
    ProviderApplication_submission = isInterface(tmp_277, SerializableProperty()) ? tmp_277 : THROW_CCE();
    var tmp_278 = get_ProviderApplication__properties()[5];
    ProviderApplication_review = isInterface(tmp_278, SerializableProperty()) ? tmp_278 : THROW_CCE();
    ProviderApplication_Submission__properties = ensureNotNull(get_serializableProperties(Companion_instance_25.serializer_9w0wvi_k$()));
    var tmp_279 = get_ProviderApplication_Submission__properties()[0];
    ProviderApplication_Submission_submittedAt = isInterface(tmp_279, SerializableProperty()) ? tmp_279 : THROW_CCE();
    var tmp_280 = get_ProviderApplication_Submission__properties()[1];
    ProviderApplication_Submission_provider = isInterface(tmp_280, SerializableProperty()) ? tmp_280 : THROW_CCE();
    ProviderApplication_Review__properties = ensureNotNull(get_serializableProperties(Companion_instance_26.serializer_9w0wvi_k$()));
    var tmp_281 = get_ProviderApplication_Review__properties()[0];
    ProviderApplication_Review_reviewedAt = isInterface(tmp_281, SerializableProperty()) ? tmp_281 : THROW_CCE();
    var tmp_282 = get_ProviderApplication_Review__properties()[1];
    ProviderApplication_Review_approved = isInterface(tmp_282, SerializableProperty()) ? tmp_282 : THROW_CCE();
    var tmp_283 = get_ProviderApplication_Review__properties()[2];
    ProviderApplication_Review_resultingProvider = isInterface(tmp_283, SerializableProperty()) ? tmp_283 : THROW_CCE();
    CareLocationProgram__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_20().serializer_9w0wvi_k$()));
    var tmp_284 = get_CareLocationProgram__properties()[0];
    CareLocationProgram__id = isInterface(tmp_284, SerializableProperty()) ? tmp_284 : THROW_CCE();
    var tmp_285 = get_CareLocationProgram__properties()[1];
    CareLocationProgram_location = isInterface(tmp_285, SerializableProperty()) ? tmp_285 : THROW_CCE();
    var tmp_286 = get_CareLocationProgram__properties()[2];
    CareLocationProgram_provider = isInterface(tmp_286, SerializableProperty()) ? tmp_286 : THROW_CCE();
    var tmp_287 = get_CareLocationProgram__properties()[3];
    CareLocationProgram_name = isInterface(tmp_287, SerializableProperty()) ? tmp_287 : THROW_CCE();
    var tmp_288 = get_CareLocationProgram__properties()[4];
    CareLocationProgram_template = isInterface(tmp_288, SerializableProperty()) ? tmp_288 : THROW_CCE();
    var tmp_289 = get_CareLocationProgram__properties()[5];
    CareLocationProgram_templateSince = isInterface(tmp_289, SerializableProperty()) ? tmp_289 : THROW_CCE();
    var tmp_290 = get_CareLocationProgram__properties()[6];
    CareLocationProgram_active = isInterface(tmp_290, SerializableProperty()) ? tmp_290 : THROW_CCE();
    var tmp_291 = get_CareLocationProgram__properties()[7];
    CareLocationProgram_careTime = isInterface(tmp_291, SerializableProperty()) ? tmp_291 : THROW_CCE();
    var tmp_292 = get_CareLocationProgram__properties()[8];
    CareLocationProgram_ageStart = isInterface(tmp_292, SerializableProperty()) ? tmp_292 : THROW_CCE();
    var tmp_293 = get_CareLocationProgram__properties()[9];
    CareLocationProgram_ageEndInclusive = isInterface(tmp_293, SerializableProperty()) ? tmp_293 : THROW_CCE();
    var tmp_294 = get_CareLocationProgram__properties()[10];
    CareLocationProgram_availableAsIntermittent = isInterface(tmp_294, SerializableProperty()) ? tmp_294 : THROW_CCE();
    CareLocationProgramDated__properties = ensureNotNull(get_serializableProperties(Companion_instance_27.serializer_9w0wvi_k$()));
    var tmp_295 = get_CareLocationProgramDated__properties()[0];
    CareLocationProgramDated__id = isInterface(tmp_295, SerializableProperty()) ? tmp_295 : THROW_CCE();
    var tmp_296 = get_CareLocationProgramDated__properties()[1];
    CareLocationProgramDated_program = isInterface(tmp_296, SerializableProperty()) ? tmp_296 : THROW_CCE();
    var tmp_297 = get_CareLocationProgramDated__properties()[2];
    CareLocationProgramDated_location = isInterface(tmp_297, SerializableProperty()) ? tmp_297 : THROW_CCE();
    var tmp_298 = get_CareLocationProgramDated__properties()[3];
    CareLocationProgramDated_provider = isInterface(tmp_298, SerializableProperty()) ? tmp_298 : THROW_CCE();
    var tmp_299 = get_CareLocationProgramDated__properties()[4];
    CareLocationProgramDated_template = isInterface(tmp_299, SerializableProperty()) ? tmp_299 : THROW_CCE();
    var tmp_300 = get_CareLocationProgramDated__properties()[5];
    CareLocationProgramDated_name = isInterface(tmp_300, SerializableProperty()) ? tmp_300 : THROW_CCE();
    var tmp_301 = get_CareLocationProgramDated__properties()[6];
    CareLocationProgramDated_templateDated = isInterface(tmp_301, SerializableProperty()) ? tmp_301 : THROW_CCE();
    var tmp_302 = get_CareLocationProgramDated__properties()[7];
    CareLocationProgramDated_activeRange = isInterface(tmp_302, SerializableProperty()) ? tmp_302 : THROW_CCE();
    var tmp_303 = get_CareLocationProgramDated__properties()[8];
    CareLocationProgramDated_price = isInterface(tmp_303, SerializableProperty()) ? tmp_303 : THROW_CCE();
    var tmp_304 = get_CareLocationProgramDated__properties()[9];
    CareLocationProgramDated_transportOneWay = isInterface(tmp_304, SerializableProperty()) ? tmp_304 : THROW_CCE();
    var tmp_305 = get_CareLocationProgramDated__properties()[10];
    CareLocationProgramDated_transportTwoWay = isInterface(tmp_305, SerializableProperty()) ? tmp_305 : THROW_CCE();
    CareProgramTemplate__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_21().serializer_9w0wvi_k$()));
    var tmp_306 = get_CareProgramTemplate__properties()[0];
    CareProgramTemplate__id = isInterface(tmp_306, SerializableProperty()) ? tmp_306 : THROW_CCE();
    var tmp_307 = get_CareProgramTemplate__properties()[1];
    CareProgramTemplate_name = isInterface(tmp_307, SerializableProperty()) ? tmp_307 : THROW_CCE();
    var tmp_308 = get_CareProgramTemplate__properties()[2];
    CareProgramTemplate_shortName = isInterface(tmp_308, SerializableProperty()) ? tmp_308 : THROW_CCE();
    var tmp_309 = get_CareProgramTemplate__properties()[3];
    CareProgramTemplate_careTime = isInterface(tmp_309, SerializableProperty()) ? tmp_309 : THROW_CCE();
    var tmp_310 = get_CareProgramTemplate__properties()[4];
    CareProgramTemplate_ageStart = isInterface(tmp_310, SerializableProperty()) ? tmp_310 : THROW_CCE();
    var tmp_311 = get_CareProgramTemplate__properties()[5];
    CareProgramTemplate_ageEndInclusive = isInterface(tmp_311, SerializableProperty()) ? tmp_311 : THROW_CCE();
    var tmp_312 = get_CareProgramTemplate__properties()[6];
    CareProgramTemplate_availableAsIntermittent = isInterface(tmp_312, SerializableProperty()) ? tmp_312 : THROW_CCE();
    CareProgramTemplateDated__properties = ensureNotNull(get_serializableProperties(Companion_instance_28.serializer_9w0wvi_k$()));
    var tmp_313 = get_CareProgramTemplateDated__properties()[0];
    CareProgramTemplateDated__id = isInterface(tmp_313, SerializableProperty()) ? tmp_313 : THROW_CCE();
    var tmp_314 = get_CareProgramTemplateDated__properties()[1];
    CareProgramTemplateDated_template = isInterface(tmp_314, SerializableProperty()) ? tmp_314 : THROW_CCE();
    var tmp_315 = get_CareProgramTemplateDated__properties()[2];
    CareProgramTemplateDated_activeRange = isInterface(tmp_315, SerializableProperty()) ? tmp_315 : THROW_CCE();
    var tmp_316 = get_CareProgramTemplateDated__properties()[3];
    CareProgramTemplateDated_price = isInterface(tmp_316, SerializableProperty()) ? tmp_316 : THROW_CCE();
    var tmp_317 = get_CareProgramTemplateDated__properties()[4];
    CareProgramTemplateDated_transportOneWay = isInterface(tmp_317, SerializableProperty()) ? tmp_317 : THROW_CCE();
    var tmp_318 = get_CareProgramTemplateDated__properties()[5];
    CareProgramTemplateDated_transportTwoWay = isInterface(tmp_318, SerializableProperty()) ? tmp_318 : THROW_CCE();
    Survey__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_22().serializer_9w0wvi_k$()));
    var tmp_319 = get_Survey__properties()[0];
    Survey__id = isInterface(tmp_319, SerializableProperty()) ? tmp_319 : THROW_CCE();
    var tmp_320 = get_Survey__properties()[1];
    Survey_name = isInterface(tmp_320, SerializableProperty()) ? tmp_320 : THROW_CCE();
    var tmp_321 = get_Survey__properties()[2];
    Survey_available = isInterface(tmp_321, SerializableProperty()) ? tmp_321 : THROW_CCE();
    var tmp_322 = get_Survey__properties()[3];
    Survey_maximumFrequency = isInterface(tmp_322, SerializableProperty()) ? tmp_322 : THROW_CCE();
    var tmp_323 = get_Survey__properties()[4];
    Survey_questions = isInterface(tmp_323, SerializableProperty()) ? tmp_323 : THROW_CCE();
    var tmp_324 = get_Survey__properties()[5];
    Survey_audience = isInterface(tmp_324, SerializableProperty()) ? tmp_324 : THROW_CCE();
    var tmp_325 = get_Survey__properties()[6];
    Survey_translations = isInterface(tmp_325, SerializableProperty()) ? tmp_325 : THROW_CCE();
    Question__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_23().serializer_9w0wvi_k$()));
    var tmp_326 = get_Question__properties()[0];
    Question__id = isInterface(tmp_326, SerializableProperty()) ? tmp_326 : THROW_CCE();
    var tmp_327 = get_Question__properties()[1];
    Question_question = isInterface(tmp_327, SerializableProperty()) ? tmp_327 : THROW_CCE();
    var tmp_328 = get_Question__properties()[2];
    Question_item = isInterface(tmp_328, SerializableProperty()) ? tmp_328 : THROW_CCE();
    var tmp_329 = get_Question__properties()[3];
    Question_type = isInterface(tmp_329, SerializableProperty()) ? tmp_329 : THROW_CCE();
    var tmp_330 = get_Question__properties()[4];
    Question_optional = isInterface(tmp_330, SerializableProperty()) ? tmp_330 : THROW_CCE();
    var tmp_331 = get_Question__properties()[5];
    Question_employerMaySeeResponse = isInterface(tmp_331, SerializableProperty()) ? tmp_331 : THROW_CCE();
    var tmp_332 = get_Question__properties()[6];
    Question_showCondition = isInterface(tmp_332, SerializableProperty()) ? tmp_332 : THROW_CCE();
    Question_ShowCondition__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_24().serializer_9w0wvi_k$()));
    var tmp_333 = get_Question_ShowCondition__properties()[0];
    Question_ShowCondition_otherQuestion = isInterface(tmp_333, SerializableProperty()) ? tmp_333 : THROW_CCE();
    var tmp_334 = get_Question_ShowCondition__properties()[1];
    Question_ShowCondition_answerIsOneOf = isInterface(tmp_334, SerializableProperty()) ? tmp_334 : THROW_CCE();
    QuestionResponse__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_25().serializer_9w0wvi_k$()));
    var tmp_335 = get_QuestionResponse__properties()[0];
    QuestionResponse__id = isInterface(tmp_335, SerializableProperty()) ? tmp_335 : THROW_CCE();
    var tmp_336 = get_QuestionResponse__properties()[1];
    QuestionResponse_survey = isInterface(tmp_336, SerializableProperty()) ? tmp_336 : THROW_CCE();
    var tmp_337 = get_QuestionResponse__properties()[2];
    QuestionResponse_question = isInterface(tmp_337, SerializableProperty()) ? tmp_337 : THROW_CCE();
    var tmp_338 = get_QuestionResponse__properties()[3];
    QuestionResponse_takerType = isInterface(tmp_338, SerializableProperty()) ? tmp_338 : THROW_CCE();
    var tmp_339 = get_QuestionResponse__properties()[4];
    QuestionResponse_takerId = isInterface(tmp_339, SerializableProperty()) ? tmp_339 : THROW_CCE();
    var tmp_340 = get_QuestionResponse__properties()[5];
    QuestionResponse_takerIteration = isInterface(tmp_340, SerializableProperty()) ? tmp_340 : THROW_CCE();
    var tmp_341 = get_QuestionResponse__properties()[6];
    QuestionResponse_employerMaySeeResponse = isInterface(tmp_341, SerializableProperty()) ? tmp_341 : THROW_CCE();
    var tmp_342 = get_QuestionResponse__properties()[7];
    QuestionResponse_demographic = isInterface(tmp_342, SerializableProperty()) ? tmp_342 : THROW_CCE();
    var tmp_343 = get_QuestionResponse__properties()[8];
    QuestionResponse_at = isInterface(tmp_343, SerializableProperty()) ? tmp_343 : THROW_CCE();
    var tmp_344 = get_QuestionResponse__properties()[9];
    QuestionResponse_answerFreeText = isInterface(tmp_344, SerializableProperty()) ? tmp_344 : THROW_CCE();
    var tmp_345 = get_QuestionResponse__properties()[10];
    QuestionResponse_answerSingleChoice = isInterface(tmp_345, SerializableProperty()) ? tmp_345 : THROW_CCE();
    var tmp_346 = get_QuestionResponse__properties()[11];
    QuestionResponse_answerMultipleChoice = isInterface(tmp_346, SerializableProperty()) ? tmp_346 : THROW_CCE();
    var tmp_347 = get_QuestionResponse__properties()[12];
    QuestionResponse_answerScale = isInterface(tmp_347, SerializableProperty()) ? tmp_347 : THROW_CCE();
    var tmp_348 = get_QuestionResponse__properties()[13];
    QuestionResponse_answerFreeNumber = isInterface(tmp_348, SerializableProperty()) ? tmp_348 : THROW_CCE();
    QuestionResponse_Demographic__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_26().serializer_9w0wvi_k$()));
    var tmp_349 = get_QuestionResponse_Demographic__properties()[0];
    QuestionResponse_Demographic_supportingEmployers = isInterface(tmp_349, SerializableProperty()) ? tmp_349 : THROW_CCE();
    var tmp_350 = get_QuestionResponse_Demographic__properties()[1];
    QuestionResponse_Demographic_supportingGrants = isInterface(tmp_350, SerializableProperty()) ? tmp_350 : THROW_CCE();
    var tmp_351 = get_QuestionResponse_Demographic__properties()[2];
    QuestionResponse_Demographic_takerEmployer = isInterface(tmp_351, SerializableProperty()) ? tmp_351 : THROW_CCE();
    var tmp_352 = get_QuestionResponse_Demographic__properties()[3];
    QuestionResponse_Demographic_income = isInterface(tmp_352, SerializableProperty()) ? tmp_352 : THROW_CCE();
    var tmp_353 = get_QuestionResponse_Demographic__properties()[4];
    QuestionResponse_Demographic_leadershipLevel = isInterface(tmp_353, SerializableProperty()) ? tmp_353 : THROW_CCE();
    var tmp_354 = get_QuestionResponse_Demographic__properties()[5];
    QuestionResponse_Demographic_familySize = isInterface(tmp_354, SerializableProperty()) ? tmp_354 : THROW_CCE();
    var tmp_355 = get_QuestionResponse_Demographic__properties()[6];
    QuestionResponse_Demographic_city = isInterface(tmp_355, SerializableProperty()) ? tmp_355 : THROW_CCE();
    SurveyProgress__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_27().serializer_9w0wvi_k$()));
    var tmp_356 = get_SurveyProgress__properties()[0];
    SurveyProgress__id = isInterface(tmp_356, SerializableProperty()) ? tmp_356 : THROW_CCE();
    var tmp_357 = get_SurveyProgress__properties()[1];
    SurveyProgress_survey = isInterface(tmp_357, SerializableProperty()) ? tmp_357 : THROW_CCE();
    var tmp_358 = get_SurveyProgress__properties()[2];
    SurveyProgress_takerType = isInterface(tmp_358, SerializableProperty()) ? tmp_358 : THROW_CCE();
    var tmp_359 = get_SurveyProgress__properties()[3];
    SurveyProgress_takerId = isInterface(tmp_359, SerializableProperty()) ? tmp_359 : THROW_CCE();
    var tmp_360 = get_SurveyProgress__properties()[4];
    SurveyProgress_takerIteration = isInterface(tmp_360, SerializableProperty()) ? tmp_360 : THROW_CCE();
    var tmp_361 = get_SurveyProgress__properties()[5];
    SurveyProgress_demographic = isInterface(tmp_361, SerializableProperty()) ? tmp_361 : THROW_CCE();
    var tmp_362 = get_SurveyProgress__properties()[6];
    SurveyProgress_startedAt = isInterface(tmp_362, SerializableProperty()) ? tmp_362 : THROW_CCE();
    var tmp_363 = get_SurveyProgress__properties()[7];
    SurveyProgress_completedAt = isInterface(tmp_363, SerializableProperty()) ? tmp_363 : THROW_CCE();
    SignatureSession__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_28().serializer_9w0wvi_k$()));
    var tmp_364 = get_SignatureSession__properties()[0];
    SignatureSession_envelopeId = isInterface(tmp_364, SerializableProperty()) ? tmp_364 : THROW_CCE();
    var tmp_365 = get_SignatureSession__properties()[1];
    SignatureSession_redirects = isInterface(tmp_365, SerializableProperty()) ? tmp_365 : THROW_CCE();
    var tmp_366 = get_SignatureSession__properties()[2];
    SignatureSession_expiresAt = isInterface(tmp_366, SerializableProperty()) ? tmp_366 : THROW_CCE();
    SignerStatus__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_29().serializer_9w0wvi_k$()));
    var tmp_367 = get_SignerStatus__properties()[0];
    SignerStatus_email = isInterface(tmp_367, SerializableProperty()) ? tmp_367 : THROW_CCE();
    var tmp_368 = get_SignerStatus__properties()[1];
    SignerStatus_status = isInterface(tmp_368, SerializableProperty()) ? tmp_368 : THROW_CCE();
    SignatureStatusDetails__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_30().serializer_9w0wvi_k$()));
    var tmp_369 = get_SignatureStatusDetails__properties()[0];
    SignatureStatusDetails_envelopeId = isInterface(tmp_369, SerializableProperty()) ? tmp_369 : THROW_CCE();
    var tmp_370 = get_SignatureStatusDetails__properties()[1];
    SignatureStatusDetails_status = isInterface(tmp_370, SerializableProperty()) ? tmp_370 : THROW_CCE();
    var tmp_371 = get_SignatureStatusDetails__properties()[2];
    SignatureStatusDetails_signerStatuses = isInterface(tmp_371, SerializableProperty()) ? tmp_371 : THROW_CCE();
    var tmp_372 = get_SignatureStatusDetails__properties()[3];
    SignatureStatusDetails_completedAt = isInterface(tmp_372, SerializableProperty()) ? tmp_372 : THROW_CCE();
    var tmp_373 = get_SignatureStatusDetails__properties()[4];
    SignatureStatusDetails_metadata = isInterface(tmp_373, SerializableProperty()) ? tmp_373 : THROW_CCE();
    ScheduledAttendance__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_31().serializer_9w0wvi_k$()));
    var tmp_374 = get_ScheduledAttendance__properties()[0];
    ScheduledAttendance_time = isInterface(tmp_374, SerializableProperty()) ? tmp_374 : THROW_CCE();
    var tmp_375 = get_ScheduledAttendance__properties()[1];
    ScheduledAttendance_transportFrom = isInterface(tmp_375, SerializableProperty()) ? tmp_375 : THROW_CCE();
    var tmp_376 = get_ScheduledAttendance__properties()[2];
    ScheduledAttendance_transportTo = isInterface(tmp_376, SerializableProperty()) ? tmp_376 : THROW_CCE();
    var tmp_377 = get_ScheduledAttendance__properties()[3];
    ScheduledAttendance_timeWhenIntermittent = isInterface(tmp_377, SerializableProperty()) ? tmp_377 : THROW_CCE();
    ExpectedAttendance__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_32().serializer_9w0wvi_k$()));
    var tmp_378 = get_ExpectedAttendance__properties()[0];
    ExpectedAttendance_scheduled = isInterface(tmp_378, SerializableProperty()) ? tmp_378 : THROW_CCE();
    var tmp_379 = get_ExpectedAttendance__properties()[1];
    ExpectedAttendance_closure = isInterface(tmp_379, SerializableProperty()) ? tmp_379 : THROW_CCE();
    ActualAttendance__properties = ensureNotNull(get_serializableProperties(Companion_getInstance_33().serializer_9w0wvi_k$()));
    var tmp_380 = get_ActualAttendance__properties()[0];
    ActualAttendance_scheduled = isInterface(tmp_380, SerializableProperty()) ? tmp_380 : THROW_CCE();
    var tmp_381 = get_ActualAttendance__properties()[1];
    ActualAttendance_case = isInterface(tmp_381, SerializableProperty()) ? tmp_381 : THROW_CCE();
    var tmp_382 = get_ActualAttendance__properties()[2];
    ActualAttendance_useIntermittent = isInterface(tmp_382, SerializableProperty()) ? tmp_382 : THROW_CCE();
    var tmp_383 = get_ActualAttendance__properties()[3];
    ActualAttendance_transportTo = isInterface(tmp_383, SerializableProperty()) ? tmp_383 : THROW_CCE();
    var tmp_384 = get_ActualAttendance__properties()[4];
    ActualAttendance_transportFrom = isInterface(tmp_384, SerializableProperty()) ? tmp_384 : THROW_CCE();
  }
}
//region block: exports
export {
  get__id_2 as get__id2p9nbcwbj0zlw,
  get__id_4 as get__id2ft65q2wfav1v,
  get__id_7 as get__id1elsu38391a1o,
  get__id_0 as get__id336i6k806byxy,
  get__id_6 as get__idsxxkn2fqoor7,
  get__id_1 as get__id1301miildb0kq,
  get__id as get__id1hi7gtah39onn,
  get__id_5 as get__id3cxe3uvvwx5bo,
  get__id_3 as get__id21dvlw9jjogre,
  get_active_0 as get_active1vjezlaggokv5,
  get_active_5 as get_active2j9ehubxjx5nv,
  get_active as get_active17ysivz5d1f67,
  get_active_1 as get_activer7k472kwlyvl,
  get_active_2 as get_active3agrrcv2mhqn,
  get_active_4 as get_activey9flk4wg8xgv,
  get_active_3 as get_activeyldcfkk8bem8,
  get_activeRange_2 as get_activeRange1esci1i2m7f7u,
  get_activeRange as get_activeRangedsifhrs4gcfc,
  get_activeRange_4 as get_activeRanget5bqi8ppra1m,
  get_activeRange_5 as get_activeRange1133ufp87xqbu,
  get_activeRange_1 as get_activeRange3cy9292uwsomj,
  get_activeRange_3 as get_activeRange3uh32mrsnkkqp,
  get_activeRange_0 as get_activeRange2dh4qyh6z7x7z,
  get_address as get_address2uhm0456nbriz,
  get_address_0 as get_address1er1ty3qehev7,
  get_administration_0 as get_administration10gy4bax4zsbe,
  get_administration as get_administration1i905jzi65gk6,
  get_ageEndInclusive as get_ageEndInclusive1cq80r5bv8q1x,
  get_ageStart as get_ageStart2z6gzlaamhsp,
  get_alternatePhone as get_alternatePhone3s5tf4bybwvr0,
  get_amount as get_amount20hb291w08kcp,
  get_answerFreeNumber as get_answerFreeNumber3m8fwci6bexgk,
  get_answerMultipleChoice as get_answerMultipleChoice1d0eh30iadr4j,
  get_answerScale as get_answerScale2z0xdsq82vzwn,
  get_answerSingleChoice as get_answerSingleChoice1bo4u7v2iayry,
  get_approved as get_approved221jlb71nbap0,
  get_approved_0 as get_approved3bkx12y4t4oji,
  get_approved_1 as get_approved3gqdk01w6etbr,
  get_at_0 as get_at2gqzbsr4s5j1f,
  get_at as get_at3sb6rh0fwrxhw,
  get_at_1 as get_at32g2hzsls3ow0,
  get_attendance as get_attendance2q4781hmwhput,
  get_available as get_available29p7gsw45t1wj,
  get_availableAsIntermittent as get_availableAsIntermittent2wvvnkqvc4qfv,
  get_billingAddress as get_billingAddress2jws2mkpoutb7,
  get_billingContactName as get_billingContactName2pajxzqwevsfd,
  get_birthDate as get_birthDate38i0hzdi7d6gu,
  get_birthDate_0 as get_birthDate2r259t5gzdpld,
  get_breakdown as get_breakdown3ggnps1coozif,
  get_careProvider as get_careProvider2yy6e55u6ryn2,
  get_careProvider_0 as get_careProvider2u75olyzxhmjt,
  get_careTime as get_careTime1h5171nvh773w,
  get_child as get_child3h7gqdbfa6g6t,
  get_childName as get_childName2bddylpcm0ja3,
  get_children as get_childrentbpstb2ynusu,
  get_city_0 as get_city2k035u7pra9ih,
  get_city as get_city182djzl8rp5cw,
  get_completedAt as get_completedAt2o81s1ul0ktr1,
  get_contact_1 as get_contact196vi87vu7eim,
  get_contact_0 as get_contacteqygr3gdfszq,
  get_contact as get_contact2nyc8wbyivmn,
  get_createdAt_0 as get_createdAtjlvwlbuc0vu0,
  get_createdAt as get_createdAt3vhv4gzp0xb8r,
  get_createdAt_1 as get_createdAt25zyw3ew6pt0,
  get_date_0 as get_date4gxx2ixf9cue,
  get_date as get_date13hdmf8teioql,
  get_demographic as get_demographicmlqzvs0t1ul4,
  get_email as get_email13agc7d6ft82j,
  get_email_1 as get_emailbv7cfcsvgkdr,
  get_email_0 as get_email2vebsqfvcm8pu,
  get_employer_3 as get_employer10g54kx25vga3,
  get_employer_1 as get_employer2gb4y0u0mfqpe,
  get_employer as get_employerfduycfo0q5pn,
  get_employer_0 as get_employer210syo9zdd2nz,
  get_employer_2 as get_employergdu8c3bkfw8,
  get_employerContributions as get_employerContributionsrrrn8wrmt5nc,
  get_employers as get_employers2nozrigfcaz4w,
  get_endInclusive as get_endInclusive3dsvnewm08bor,
  get_endInclusive_0 as get_endInclusive2wh7ub8763o5h,
  get_endReason as get_endReason3vau3evhhkid6,
  get_endReasonNotes as get_endReasonNotes2xagugicvgko8,
  get_family_2 as get_family2au8kxs7mi7t5,
  get_family as get_familyraw6f29ztw22,
  get_family_0 as get_family3q4ofyk7cegoi,
  get_family_1 as get_family33agsz30e7i0a,
  get_family_3 as get_family1otacd6yt55oz,
  get_familySize as get_familySize3udi93tkuiabd,
  get_familySize_0 as get_familySizeg8giw0lzo5tk,
  get_firstName as get_firstName1l2zu2fsbg08t,
  get_firstName_0 as get_firstName3blaveac0mrqf,
  get_forDate as get_forDate3tzeotrzulxwz,
  get_forDates as get_forDatesipvp1vaghli1,
  get_funder as get_funder25hurj3mboj3p,
  get_gender_0 as get_gender1ue2tducd3zez,
  get_gender as get_gendernv45red4ydcb,
  get_grant_0 as get_grant3rlqon2bl3pn7,
  get_grant_1 as get_grant16jjr24y2ahic,
  get_grant as get_grant2comy80he6eab,
  get_grantContributions as get_grantContributionsaz7v0xwh5pzh,
  get_grants as get_grants3pvkn0u5vub3i,
  get_income as get_income7rv80eiwnca0,
  get_informationVerifiedAt as get_informationVerifiedAtipq77z9u37x4,
  get_invitedUsers_0 as get_invitedUsers2sllg41nh1v2v,
  get_invitedUsers as get_invitedUsers2grm04jnkmtlg,
  get_lastName as get_lastNameeb1r6zhucrxq,
  get_lastName_0 as get_lastName3bf5kvm2i63yd,
  get_leadershipLevel as get_leadershipLevel3vlrbz5tqiro3,
  get_line1 as get_line12qowz8aajkggm,
  get_line2 as get_line22yru7ztqlgmow,
  get_location_1 as get_locationrgfu4uek4c14,
  get_location_3 as get_location2f1azencio7x2,
  get_location as get_location1p3um6ao7ento,
  get_location_4 as get_location293x913xs6wdd,
  get_location_0 as get_location5qvftw9oaw3d,
  get_location_2 as get_location22dxferxpyzkz,
  get_managesEmployers as get_managesEmployerscxv9xf6aqew1,
  get_managesFamilies as get_managesFamiliesqhp25q3m346r,
  get_managesLocations as get_managesLocations32fghveu592vx,
  get_managesProviders as get_managesProviders1061ox89jyaox,
  get_month as get_month19qfpo3x38uey,
  get_name_2 as get_name2gnjdlpbm0se5,
  get_name_1 as get_name27z06mu1petol,
  get_name_0 as get_name29bc1mdqu6171,
  get_name_4 as get_name1iemflb9d8z7b,
  get_name_6 as get_name3aern4pcdmrjz,
  get_name_3 as get_name2lx8u3d4hog3p,
  get_name_5 as get_name3rurt0joopy8d,
  get_name as get_name3gijmx3xstqlj,
  get_notes as get_notes3fzrm6frp2n4s,
  get_offersTransportation as get_offersTransportation17zpg1z1kf9iz,
  get_period as get_periodnytt0bk9l5et,
  get_phone_1 as get_phoneph41zjp0zq4b,
  get_phone as get_phone31swsuqbmo9e,
  get_phone_0 as get_phone27h5zus6ceaut,
  get_platform as get_platform114v8tgyas4i,
  get_postalCode as get_postalCodeb3j2izx1u631,
  get_preferredLanguage_0 as get_preferredLanguage2fe7014lb3h3h,
  get_preferredLanguage as get_preferredLanguage1xl103nz1xya4,
  get_price as get_price2xrsb653e7yz0,
  get_primaryParent as get_primaryParent1y63p7tb3kpdx,
  get_program as get_program2j5nucnpibn8o,
  get_provider_1 as get_providerwos77hd4slhf,
  get_provider_4 as get_provider3mtu6uzbh0coh,
  get_provider_2 as get_provider1s9y5fs8n0r3w,
  get_provider_0 as get_provider236l3o795o21w,
  get_provider as get_provider3ji4mrhteqv5h,
  get_provider_3 as get_provider32psqg9zb0w7e,
  get_providerName as get_providerName1j4z1getwwg09,
  get_question as get_question2rd5ppp1vbac2,
  get_race_0 as get_race1qlprp2znhxws,
  get_race as get_race389ah166bty32,
  get_reason_0 as get_reason1ko0kprsi3ohd,
  get_reason as get_reason1ql5s15ou11ka,
  get_reason_1 as get_reasondtlrxf4x79mr,
  get_remittance as get_remittance317c7kdoa7qw,
  get_review as get_review35f4yosw8k9cn,
  get_review_0 as get_reviewjqvgm91l8fp3,
  get_role as get_role1nin6e4oapglm,
  get_secondaryParent as get_secondaryParent11vqc6r832a2n,
  get_sentTo as get_sentTo321ekxiln2x6w,
  get_sentTo_0 as get_sentTo223hhuy0hzmcm,
  get_shortId as get_shortIdrr7ewqm2hsnc,
  get_shortName as get_shortNameii4jpwm36hhh,
  get_signedDocument as get_signedDocument3640hkwsv7915,
  get_start as get_start1ib7kl469eh9c,
  get_start_0 as get_start30tbw38mnjak0,
  get_state as get_state1oesqq81882tl,
  get_status as get_statusn2vo2y7gh1yq,
  get_submission_0 as get_submission3ha7ltsjel3fd,
  get_submission as get_submissionxklyxsg05uep,
  get_submitted as get_submitted382abp2i1n972,
  get_supportingEmployers as get_supportingEmployers2109hzg0jtzbr,
  get_supportingGrants as get_supportingGrants35nmqgmty3bao,
  get_survey_0 as get_survey1jt3rdrcg0rh4,
  get_survey as get_survey39c7m1qh20u4e,
  get_takerEmployer as get_takerEmployer1i90yvm39mbzg,
  get_takerId_0 as get_takerId1ugw8co5t0vwh,
  get_takerId as get_takerId2o30vx45bol9y,
  get_takerIteration_0 as get_takerIteration39isn1ebcp9sd,
  get_takerIteration as get_takerIteration1i7xba92wxwha,
  get_takerType as get_takerType1ndu8mc2kn1bw,
  get_template as get_templateerawh75uwil7,
  get_template_0 as get_template1m0dwy8u7b927,
  get_templateSince as get_templateSince32usg3af6gzni,
  get_transportOneWay as get_transportOneWay2b2salmzx1v85,
  get_transportTwoWay as get_transportTwoWay1ju1bbhgmnodz,
  get_type as get_typeq73z1u2l6557,
  get_vendorNumber as get_vendorNumber1lzwv828k7xtu,
  get_voided as get_voided2matvha0tyhkf,
  get_voided_1 as get_voided7vuonke86m7o,
  get_voided_0 as get_voided2jr696tzb1zxm,
  get_voided_2 as get_voided32ny3m7cav2w3,
};
//endregion

//# sourceMappingURL=ModelFields-372156621.mjs.map
